const lang = localStorage.getItem('lang') || 'en';
const translations = JSON.parse(localStorage.getItem('customLocketLocalization')) || {};

// Variables
var startBtn = document.getElementById("start-btn");
var Btn = document.getElementById("start-btn");
var navTitle = document.getElementById("nav-title");

// ---------- MODAL HELPER FUNCTIONS ----------

function showModal(message) {
    var modal = document.getElementById("locket-modal");
    var modalMessage = document.getElementById("locket-modal-message");
    if (modal && modalMessage) {
        // If message is empty, don't overwrite existing content (for confirmation modals)
        if (message !== '') {
            // Clear any existing buttons when showing simple message
            var existingButtons = modalMessage.querySelector('.modal-buttons-container');
            if (existingButtons) {
                existingButtons.remove();
            }
            modalMessage.textContent = message;
        }
        modal.classList.remove("hide");
    }
}

function hideModal() {
    var modal = document.getElementById("locket-modal");
    if (modal) {
        modal.classList.add("hide");
    }
}

// Add event listeners for modal close (script is deferred, so DOM is ready)
function setupModalListeners() {
    var modalCloseBtn = document.getElementById("locket-modal-close");
    var modal = document.getElementById("locket-modal");
    var modalOverlay = document.querySelector(".locket-modal-overlay");
    
    if (modalCloseBtn) {
        modalCloseBtn.addEventListener("click", hideModal);
    }
    
    if (modalOverlay) {
        modalOverlay.addEventListener("click", hideModal);
    }
    
    // Close modal on Escape key
    document.addEventListener("keydown", function(event) {
        if (event.key === "Escape") {
            var modal = document.getElementById("locket-modal");
            if (modal && !modal.classList.contains("hide")) {
                hideModal();
            }
        }
    });
}

// Setup modal listeners when DOM is ready (script is deferred, so this should work immediately)
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupModalListeners);
} else {
    setupModalListeners();
}

// ---------- TEXT HELPER FUNCTIONS ----------

// Helper function to add line break in the middle of text
function setTextWithLineBreak(element, text) {
    if (!element || !text) return;
    // Split text in the middle and add line break
    var midPoint = Math.floor(text.length / 2);
    // Find the nearest space to avoid breaking words
    var breakPoint = text.lastIndexOf(' ', midPoint);
    if (breakPoint === -1) breakPoint = midPoint;
    var firstPart = text.substring(0, breakPoint);
    var secondPart = text.substring(breakPoint).trim();
    element.innerHTML = firstPart + '<br>' + secondPart;
}

// ---------- INSTRUCTION MODAL FUNCTIONS ----------

// Simple markdown to HTML converter
function markdownToHTML(markdown) {
    if (!markdown) return '';
    
    let html = markdown;
    
    // Convert headers
    html = html.replace(/^### (.*$)/gim, '<h3>$1</h3>');
    html = html.replace(/^## (.*$)/gim, '<h2>$1</h2>');
    html = html.replace(/^# (.*$)/gim, '<h1>$1</h1>');
    
    // Convert bold
    html = html.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    
    // Convert italic
    html = html.replace(/\*(.*?)\*/g, '<em>$1</em>');
    
    // Convert unordered lists
    html = html.replace(/^\- (.*$)/gim, '<li>$1</li>');
    html = html.replace(/^(\s*)\- (.*$)/gim, '<li>$2</li>');
    
    // Wrap consecutive list items in <ul>
    html = html.replace(/(<li>.*<\/li>\n?)+/g, function(match) {
        return '<ul>' + match + '</ul>';
    });
    
    // Convert paragraphs (lines that don't start with HTML tags)
    html = html.split('\n').map(function(line) {
        line = line.trim();
        if (!line) return '';
        if (line.match(/^<[h|u|o|l]/)) return line; // Already converted
        if (line.match(/^<\/[h|u|o|l]/)) return line; // Closing tags
        if (line.match(/^<li>/)) return line; // List items
        return '<p>' + line + '</p>';
    }).join('\n');
    
    // Clean up empty paragraphs
    html = html.replace(/<p><\/p>/g, '');
    html = html.replace(/<p>\s*<\/p>/g, '');
    
    return html;
}

// Load instruction content from markdown file
function loadInstructionContent(lang) {
    var instructionContent = document.getElementById("instruction-content");
    if (!instructionContent) return;
    
    // Show loading state
    instructionContent.innerHTML = '<div class="instruction-loading">Loading instructions...</div>';
    
    // Get the markdown file URL from data attributes (generated by Liquid asset_url filter)
    var markdownUrl = lang === 'ar' 
        ? instructionContent.getAttribute('data-instructions-ar')
        : instructionContent.getAttribute('data-instructions-en');
    
    if (!markdownUrl) {
        console.error('Instruction markdown URL not found');
        instructionContent.innerHTML = '<p>Error: Instruction file URL not configured.</p>';
        return;
    }
    
    console.log('Loading instructions from:', markdownUrl);
    
    // Fetch the markdown file from Shopify CDN
    fetch(markdownUrl)
        .then(function(response) {
            if (!response.ok) {
                throw new Error('Failed to load instructions: ' + response.status + ' ' + response.statusText);
            }
            return response.text();
        })
        .then(function(markdown) {
            var html = markdownToHTML(markdown);
            instructionContent.innerHTML = html;
            console.log('Instructions loaded successfully');
        })
        .catch(function(error) {
            console.error('Error loading instructions:', error);
            instructionContent.innerHTML = '<p>Error loading instructions. Please try again later.</p><p style="font-size: 12px; color: #999;">URL: ' + markdownUrl + '</p>';
        });
}

function showInstructionModal() {
    var instructionModal = document.getElementById("instruction-modal");
    if (instructionModal) {
        // Load content based on current language
        var currentLang = localStorage.getItem('lang') || 'en';
        loadInstructionContent(currentLang);
        instructionModal.classList.remove("hide");
    }
}

function hideInstructionModal() {
    var instructionModal = document.getElementById("instruction-modal");
    if (instructionModal) {
        instructionModal.classList.add("hide");
    }
}

// Setup instruction modal listeners
function setupInstructionModalListeners() {
    var instructionButton = document.getElementById("instruction-button");
    var instructionModalCloseBtn = document.getElementById("instruction-modal-close");
    var instructionModalOverlay = document.querySelector(".instruction-modal-overlay");
    
    if (instructionButton) {
        instructionButton.addEventListener("click", showInstructionModal);
    }
    
    if (instructionModalCloseBtn) {
        instructionModalCloseBtn.addEventListener("click", hideInstructionModal);
    }
    
    if (instructionModalOverlay) {
        instructionModalOverlay.addEventListener("click", hideInstructionModal);
    }
    
    // Close instruction modal on Escape key
    document.addEventListener("keydown", function(event) {
        if (event.key === "Escape") {
            var instructionModal = document.getElementById("instruction-modal");
            if (instructionModal && !instructionModal.classList.contains("hide")) {
                hideInstructionModal();
            }
        }
    });
    
    // Reload instruction content when language changes
    window.addEventListener('localstorage_updated', function() {
        var instructionModal = document.getElementById("instruction-modal");
        if (instructionModal && !instructionModal.classList.contains("hide")) {
            // Modal is open, reload content with new language
            var currentLang = localStorage.getItem('lang') || 'en';
            loadInstructionContent(currentLang);
        }
    });
}

// Setup instruction modal listeners when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
        setupInstructionModalListeners();
    });
} else {
    setupInstructionModalListeners();
}

// ---------- IMAGE UPLOAD HELPER ----------

// ImgBB API Key - Free tier allows unlimited uploads
// Sign up at: https://api.imgbb.com/
const IMGBB_API_KEY = '38b6955206085356a355fba38662370d'; // Your API key

// ---------- SCREENSHOT CAPTURE HELPER ----------

/**
 * Capture screenshot of the locket preview (divided-top-section)
 * This is called when adding to cart and before checkout
 */
async function captureLocketPreviewScreenshot(className) {
  try {
    // html2canvas logic commented out
    // // Check if html2canvas is loaded
    // if (typeof html2canvas === 'undefined') {
    //   // Load html2canvas if not already loaded
    //   return new Promise((resolve) => {
    //     const script = document.createElement('script');
    //     script.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js';
    //     script.onload = async () => {
    //       const screenshot = await performScreenshotCaptureAnyClass(className);
    //       resolve(screenshot);
    //     };
    //     script.onerror = () => {
    //       console.warn('⚠️ html2canvas failed to load');
    //       resolve(null);
    //     };
    //     document.head.appendChild(script);
    //   });
    // } else {
    //   return await performScreenshotCaptureAnyClass(className);
    // }
    return null;
  } catch (error) {
    console.error('❌ Error in captureLocketPreviewScreenshot:', error);
    return null;
  }
}

async function performScreenshotCaptureAnyClass(divClass) {
    try {
      const targetElement = document.querySelector(divClass);

      if (!targetElement) {
        console.log(`⚠️ ${divClass} not found on page`);
        return null;
      }

      console.log(`📸 Capturing screenshot of ${divClass}...`);

      // html2canvas logic commented out
      // // Use html2canvas to capture the element
      // const canvas = await html2canvas(targetElement, {
      //   backgroundColor: null,
      //   scale: window.devicePixelRatio || 2,
      //   logging: false,
      //   allowTaint: true,
      //   useCORS: false,
      //       width: 100,
      //       height: 100,
      //       onrendered: function(canvas) {
      //         console.log('Canvas rendered:', canvas.toDataURL('image/png'));
      //       }
      // });
      // const canvas = null;
      //
      // // Convert canvas to base64 image
      // const screenshotData = canvas.toDataURL('image/png');
      //
      // // Create square version of the screenshot with zoom
      // const squareSize = Math.max(canvas.width, canvas.height);
      // const squareCanvas = document.createElement('canvas');
      // squareCanvas.width = squareSize;
      // squareCanvas.height = squareSize;
      // const squareCtx = squareCanvas.getContext('2d');
      //
      // // Fill with white background
      // squareCtx.fillStyle = '#ffffff';
      // squareCtx.fillRect(0, 0, squareSize, squareSize);
      //
      // // Calculate zoom factor - scale up to fill more of the square (1.2x zoom)
      // const zoomFactor = 1.8;
      // const scaledWidth = canvas.width * zoomFactor;
      // const scaledHeight = canvas.height * zoomFactor;
      //
      // // Center the zoomed image in the square canvas
      // const offsetX = (squareSize - scaledWidth) / 2;
      // const offsetY = (squareSize - scaledHeight) / 2;
      //
      // // Draw the zoomed image
      // squareCtx.drawImage(canvas, offsetX, offsetY, scaledWidth, scaledHeight);
      //
      // // Convert square canvas to base64
      // const squareScreenshotData = squareCanvas.toDataURL('image/png');
      //
      // // Store in localStorage for later use (for checkout)
      // localStorage.setItem('locketScreenshot', screenshotData);
      // localStorage.setItem('locketScreenshotSquare', squareScreenshotData);
      // localStorage.setItem('locketScreenshotTimestamp', Date.now().toString());
      // // Hide the "Show Your Locket" button after screenshot is saved
      // if (typeof updateShowPreviewButtonVisibility === 'function') {
      //   updateShowPreviewButtonVisibility();
      // }
      //
      // console.log('✅ Locket preview screenshot captured, uploading to ImgBB...');
      //
      // // Upload original to ImgBB
      // //   const uploadResult = await uploadImageToImgBB(screenshotData);
      //
      // // Upload square version to ImgBB
      // //   const squareUploadResult = await uploadImageToImgBB(squareScreenshotData);
      //
      // //   if (uploadResult && uploadResult.url) {
      // //     // Store URL in localStorage
      // //     localStorage.setItem('locketScreenshotURL', uploadResult.url);
      // //     localStorage.setItem('locketScreenshotThumbnail', uploadResult.thumb_url || uploadResult.url);
      // //     localStorage.setItem('locketScreenshotMedium', uploadResult.medium_url || uploadResult.url);
      //
      // //     // Store square version URL
      // //     if (squareUploadResult && squareUploadResult.url) {
      // //       localStorage.setItem('locketScreenshotSquareURL', squareUploadResult.url);
      // //       localStorage.setItem('locketScreenshotSquareThumbnail', squareUploadResult.thumb_url || squareUploadResult.url);
      // //       localStorage.setItem('locketScreenshotSquareMedium', squareUploadResult.medium_url || squareUploadResult.url);
      // //       console.log('✅ Square screenshot uploaded to ImgBB:', squareUploadResult.url);
      // //     }
      //
      // //     console.log('✅ Screenshot uploaded to ImgBB:', uploadResult.url);
      //
      //     return {
      //       base64: screenshotData,
      //       squareBase64: squareScreenshotData,
      //       url: uploadResult.url,
      //       squareUrl: squareUploadResult?.url || null,
      //       thumbnail: uploadResult.thumb_url || uploadResult.url,
      //       squareThumbnail: squareUploadResult?.thumb_url || squareUploadResult?.url || null,
      //       medium: uploadResult.medium_url || uploadResult.url,
      //       squareMedium: squareUploadResult?.medium_url || squareUploadResult?.url || null
      //     };
      // //   } else {
      // //     console.warn('⚠️ Screenshot upload failed, keeping base64 only');
      // //     return {
      // //       base64: screenshotData,
      // //       squareBase64: squareScreenshotData,
      // //       url: null,
      // //       squareUrl: null
      // //     };
      // //   }
      return null;
    } catch (error) {
      console.error('❌ Error capturing screenshot:', error);
      return null;
    }
  }

/**
 * Perform the actual screenshot capture and upload to ImgBB
 */
async function performScreenshotCapture() {
  try {
    const targetElement = document.querySelector('.divided-top-section');
    
    if (!targetElement) {
      console.log('⚠️ divided-top-section not found on page');
      return null;
    }
    
    console.log('📸 Capturing screenshot of locket preview...');
    console.log('📐 Element dimensions:', {
      width: targetElement.offsetWidth,
      height: targetElement.offsetHeight
    });
    
    // html2canvas logic commented out
    // // Use html2canvas to capture the element
    // const canvas = await html2canvas(targetElement, {
    //   backgroundColor: null,
    //   scale: 2, // Higher quality
    //   logging: false,
    //   useCORS: true,
    //   allowTaint: true,
    //   width: targetElement.offsetWidth,
    //   height: targetElement.offsetHeight
    // });
    // const canvas = null;
    return null;

    // html2canvas logic commented out - all canvas processing code below
    // // Convert canvas to base64 image
    // const screenshotData = canvas.toDataURL('image/png');
    //
    // // Create square version of the screenshot with zoom
    // const squareSize = Math.max(canvas.width, canvas.height);
    // const squareCanvas = document.createElement('canvas');
    // squareCanvas.width = squareSize;
    // squareCanvas.height = squareSize;
    // const squareCtx = squareCanvas.getContext('2d');
    //
    // // Fill with white background
    // squareCtx.fillStyle = '#ffffff';
    // squareCtx.fillRect(0, 0, squareSize, squareSize);
    //
    // // Calculate zoom factor - scale up to fill more of the square (1.2x zoom)
    // const zoomFactor = 1.8;
    // const scaledWidth = canvas.width * zoomFactor;
    // const scaledHeight = canvas.height * zoomFactor;
    //
    // // Center the zoomed image in the square canvas
    // const offsetX = (squareSize - scaledWidth) / 2;
    // const offsetY = (squareSize - scaledHeight) / 2;
    //
    // // Draw the zoomed image
    // squareCtx.drawImage(canvas, offsetX, offsetY, scaledWidth, scaledHeight);
    //
    // // Convert square canvas to base64
    // const squareScreenshotData = squareCanvas.toDataURL('image/png');
    //
    // // Store in localStorage for later use (for checkout)
    // localStorage.setItem('locketScreenshot', screenshotData);
    // localStorage.setItem('locketScreenshotSquare', squareScreenshotData);
    // localStorage.setItem('locketScreenshotTimestamp', Date.now().toString());
    // // Hide the "Show Your Locket" button after screenshot is saved
    // if (typeof updateShowPreviewButtonVisibility === 'function') {
    //   updateShowPreviewButtonVisibility();
    // }
    //
    // console.log('✅ Locket preview screenshot captured, uploading to ImgBB...');
    //
    // // Upload original to ImgBB
    // const uploadResult = await uploadImageToImgBB(screenshotData);
    //
    // // Upload square version to ImgBB
    // const squareUploadResult = await uploadImageToImgBB(squareScreenshotData);
    //
    // if (uploadResult && uploadResult.url) {
    //   // Store URL in localStorage
    //   localStorage.setItem('locketScreenshotURL', uploadResult.url);
    //   localStorage.setItem('locketScreenshotThumbnail', uploadResult.thumb_url || uploadResult.url);
    //   localStorage.setItem('locketScreenshotMedium', uploadResult.medium_url || uploadResult.url);
    //
    //   // Store square version URL
    //   if (squareUploadResult && squareUploadResult.url) {
    //     localStorage.setItem('locketScreenshotSquareURL', squareUploadResult.url);
    //     localStorage.setItem('locketScreenshotSquareThumbnail', squareUploadResult.thumb_url || squareUploadResult.url);
    //     localStorage.setItem('locketScreenshotSquareMedium', squareUploadResult.medium_url || squareUploadResult.url);
    //     console.log('✅ Square screenshot uploaded to ImgBB:', squareUploadResult.url);
    //   }
    //
    //   console.log('✅ Screenshot uploaded to ImgBB:', uploadResult.url);
    //
    //   return {
    //     base64: screenshotData,
    //     squareBase64: squareScreenshotData,
    //     url: uploadResult.url,
    //     squareUrl: squareUploadResult?.url || null,
    //     thumbnail: uploadResult.thumb_url || uploadResult.url,
    //     squareThumbnail: squareUploadResult?.thumb_url || squareUploadResult?.url || null,
    //     medium: uploadResult.medium_url || uploadResult.url,
    //     squareMedium: squareUploadResult?.medium_url || squareUploadResult?.url || null
    //   };
    // } else {
    //   console.warn('⚠️ Screenshot upload failed, keeping base64 only');
    //   return {
    //     base64: screenshotData,
    //     squareBase64: squareScreenshotData,
    //     url: null,
    //     squareUrl: null
    //   };
    // }
  } catch (error) {
    console.error('❌ Error capturing screenshot:', error);
    return null;
  }
}

async function uploadImageToImgBB(base64Image) {
  try {
    console.log('Uploading image to ImgBB...');
    
    // Remove data:image/...;base64, prefix if exists
    const base64Data = base64Image.replace(/^data:image\/\w+;base64,/, '');
    
    // Create form data
    const formData = new FormData();
    formData.append('key', IMGBB_API_KEY);
    formData.append('image', base64Data);
    formData.append('name', 'custom-locket-photo-' + Date.now());
    
    // Upload to ImgBB
    const url = new URL('https://api.imgbb.com/1/upload');
    url.searchParams.set('expiration', '2628000');

    const response = await fetch(url, {
    method: 'POST',
    body: formData
    });
        
    if (!response.ok) {
      throw new Error('Failed to upload image: ' + response.status);
    }
    
    const result = await response.json();
    
    if (result.success && result.data && result.data.url) {
      console.log('✅ Image uploaded successfully:', result.data.url);
      return {
        url: result.data.url,
        display_url: result.data.display_url,
        delete_url: result.data.delete_url,
        thumb_url: result.data.thumb.url,
        medium_url: result.data.medium?.url || result.data.url
      };
    } else {
      throw new Error('Invalid response from image host');
    }
    
  } catch (error) {
    console.error('❌ Image upload error:', error);
    // Return null on error - we'll handle it gracefully
    return null;
  }
}

// ---------- CART HELPER FUNCTIONS ----------

async function addToCart(variantId, quantity = 1, properties = {}) {
  try {
    console.log('Attempting to add to cart:', {
      variantId,
      quantity,
      propertiesCount: Object.keys(properties).length
    });
    
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity,
        properties: properties
      })
    });
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('Cart API Error:', response.status, errorText);
      throw new Error(`Failed to add to cart: ${response.status} - ${errorText}`);
    }
    
    const item = await response.json();
    console.log('✅ Successfully added to cart:', item.title);
    return item;
  } catch (err) {
    console.error('❌ Add to cart error:', err);
    throw err;
  }
}

async function removeFromCart(variantId) {
  try {
    const cart = await fetch('/cart.js').then(r => r.json());
    const line = cart.items.findIndex(i => i.variant_id === variantId) + 1;
    if (line > 0) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity: 0 })
      });
      console.log('Removed variant from cart:', variantId);
      await updateCartView();
    }
  } catch (err) {
    console.error('Remove from cart error:', err);
  }
}

async function updateCartView() {
  try {
    const cart = await fetch('/cart.js').then(r => r.json());
    console.log('Cart updated:', cart);
    // Trigger cart drawer update if using theme's cart drawer
    if (typeof window.dispatchEvent === 'function') {
      window.dispatchEvent(new Event('cart:refresh'));
    }
    return cart;
  } catch (err) {
    console.error('Update cart view error:', err);
  }
}

/**
 * Show loading screen overlay
 */
function showLoadingScreen(initialText) {
  // Remove existing loading screen if any
  const existingLoader = document.getElementById('custom-locket-loading-overlay');
  if (existingLoader) {
    existingLoader.remove();
  }
  
  // Create overlay
  const overlay = document.createElement('div');
  overlay.id = 'custom-locket-loading-overlay';
  overlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.85);
    z-index: 99999;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(5px);
  `;
  
  // Create spinner
  const spinner = document.createElement('div');
  spinner.style.cssText = `
    width: 60px;
    height: 60px;
    border: 5px solid rgba(255, 255, 255, 0.3);
    border-top-color: #ffffff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 30px;
  `;
  
  // Create text element with ID for easy updates
  const text = document.createElement('div');
  text.id = 'loading-screen-text';
  text.style.cssText = `
    color: #ffffff;
    font-size: 20px;
    font-weight: 500;
    text-align: center;
    padding: 0 20px;
    line-height: 1.6;
    max-width: 500px;
    white-space: pre-line;
  `;
  const baseMessage = 'Your custom locket is being added to the cart, Please don\'t refresh the screen';
  text.textContent = initialText ? `${baseMessage}\n\n${initialText}` : baseMessage;
  
  // Add spinner animation if not already added
  if (!document.getElementById('loading-spinner-style')) {
    const style = document.createElement('style');
    style.id = 'loading-spinner-style';
    style.textContent = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);
  }
  // Create aesthetic message element
const aestheticMessage = document.createElement('p');
aestheticMessage.className = 'aesthetic-loading-message';
aestheticMessage.style.cssText = `
opacity: 0;
transition: opacity 0.4s ease-in-out;
font-size: 16px;
color: rgb(255, 192, 203);
margin: 20px auto;
text-align: center;
max-width: 500px;
line-height: 1.6;
padding: 0 20px;
`;

  overlay.appendChild(aestheticMessage);
  overlay.appendChild(spinner);
  overlay.appendChild(spinner);
  overlay.appendChild(text);
  document.body.appendChild(overlay);
  
  // Prevent scrolling
  document.body.style.overflow = 'hidden';
  startAestheticMessages();
}

/**
 * Update loading screen text
 */
function updateLoadingScreenText(text) {
  const textElement = document.getElementById('loading-screen-text');
  if (textElement) {
    // Combine the base message with progress text
    const baseMessage = 'Your custom locket is being added to the cart, Please don\'t refresh the screen';
    textElement.textContent = text ? `${baseMessage}\n\n${text}` : baseMessage;
  }
}

/**
 * Hide loading screen overlay
 */
function hideLoadingScreen() {
  const overlay = document.getElementById('custom-locket-loading-overlay');
  if (overlay) {
    overlay.remove();
  }
  
  // Restore scrolling
  document.body.style.overflow = '';
}

/**
 * Clear all items from cart
 */
async function clearAllCartItems() {
  try {
    console.log('Clearing all cart items...');
    
    // Get current cart
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    
    if (cart.items && cart.items.length > 0) {
      // Build updates object to set all quantities to 0
      const updates = {};
      cart.items.forEach(item => {
        updates[item.key] = 0;
      });
      
      // Remove all items in one API call
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
      
      console.log('✅ All cart items cleared');
      
      // Update cart view if function exists
      if (typeof updateCartView === 'function') {
        await updateCartView();
      }
      
      // Trigger cart refresh event
      if (typeof window.dispatchEvent === 'function') {
        window.dispatchEvent(new Event('cart:refresh'));
      }
    }
  } catch (error) {
    console.error('❌ Error clearing cart:', error);
    throw error;
    stopAestheticMessages
  }
}


  // Function to update button progress
  function updateButtonProgress(text) {
    var confirmBtn = document.getElementById("confirm-selection-button");
    console.log('Updating button progress:', text);
    if (confirmBtn) {
      confirmBtn.innerHTML = `
        <span style="display: flex; align-items: center; justify-content: center; gap: 8px;">
          <span class="spinner" style="
            width: 16px;
            height: 16px;
            border: 2px solid #ffffff;
            border-top-color: transparent;
            border-radius: 50%;
            animation: spin 0.8s linear infinite;
            display: inline-block;
          "></span>
          <span>${text}</span>
        </span>
      `;
    }
    // Also update loading screen text
    updateLoadingScreenText(text);
  }


/**
 * Collect and add all customized locket items to cart
 */
async function addAllItemsToCart() {
  // Disable the confirm button and show progress
  const confirmBtn = document.getElementById('confirm-selection-button');
  const originalBtnText = confirmBtn ? confirmBtn.textContent : '';

  // Disable the navigation next button
  const navArrow = document.getElementById('nav-arrow');
  if (navArrow) {
    navArrow.style.pointerEvents = 'none';
    navArrow.style.opacity = '0.5';
    navArrow.style.cursor = 'not-allowed';
    navArrow.disabled = true;
    console.log('Navigation next button disabled');
  }

  if (confirmBtn) {
    confirmBtn.disabled = true;
    confirmBtn.style.opacity = '0.6';
    confirmBtn.style.cursor = 'not-allowed';
    confirmBtn.style.position = 'relative';
  }

  // Add spinner animation if not already added
  if (!document.getElementById('spinner-style')) {
    const style = document.createElement('style');
    style.id = 'spinner-style';
    style.textContent = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);
  }
  
  // Show loading screen overlay with initial text
  showLoadingScreen('Preparing...');
  
  try {
    updateButtonProgress('Starting to add all items to cart...');
    console.log('=== Starting to add all items to cart ===');
    
    // 1. Get selected locket
    const selectedLocket = JSON.parse(localStorage.getItem('selectedLocket'));
    if (!selectedLocket) {
      const currentLang = localStorage.getItem('lang') || 'en';
      const currentTranslations = JSON.parse(localStorage.getItem('customLocketLocalization')) || {};
      const errorMsg = currentTranslations[currentLang]?.error_no_locket_selected || 'Error: No locket selected';
      hideLoadingScreen();
      alert(errorMsg);
      if (confirmBtn) {
        confirmBtn.disabled = false;
        confirmBtn.style.opacity = '1';
        confirmBtn.style.cursor = 'pointer';
        confirmBtn.textContent = originalBtnText;
      }
      return;
    }
    
    // 2. Get outer charms
    const outerCharms = JSON.parse(localStorage.getItem('selectedItems')) || [];
    
    // 3. Get inner charms
    const innerCharms = JSON.parse(localStorage.getItem('innerCharms')) || [];
    
    // 4. Get custom text
    const customText = localStorage.getItem('locketCustomText');
    
    // 5. Get uploaded photo
    const uploadedPhoto = localStorage.getItem('uploadedPhoto');
    
    // 6. Get selected glitter
    const selectedGlitter = localStorage.getItem('selectedGlitter');
    
    // 6. Get Locket Screenshot (will be captured if not exists)
    let locketScreenshot = localStorage.getItem('locketScreenshot');

    // Create unique bundle ID for this custom locket
    const bundleId = `custom-locket-${Date.now()}`;
    
    console.log('Collected items:', {
      locket: selectedLocket,
      outerCharms: outerCharms.length,
      innerCharms: innerCharms.length,
      hasText: !!customText,
      hasPhoto: !!uploadedPhoto,
      hasGlitter: !!selectedGlitter
    });
    
    // Prepare line item properties for the main locket
    const locketProperties = {
      // Hidden properties (for internal use)
      '_Locket Size': selectedLocket.metafields?.dimension_description || 'N/A',
      '_Customization': 'Yes',
      '_Bundle ID': bundleId,
      '_Locked': 'true',
      '_Bundle Type': 'Custom Locket - Main',
      '_Locket Preview base64': locketScreenshot,
      // Visible properties (shown in checkout, orders, emails)
      'Locket Size': selectedLocket.metafields?.dimension_description || 'N/A',
      'Type': 'Custom Designed Locket'
    };
    
    // Capture screenshot FIRST and add URL to properties before adding to cart
    console.log('📸 Capturing screenshot before adding to cart...');

    // Capture screenshot using html2canvas before adding to cart
    if (!locketScreenshot && typeof html2canvas !== 'undefined') {
      try {
        updateButtonProgress('Capturing preview...');

        // Get the target element
        const target = document.getElementById("divided-top-section");
        if (target) {
          // Store original display styles to restore later
          const elementsToHide = [];

          // Hide middle and bottom sections
          const middleSection = document.getElementById("divided-middle-section");
          const bottomSection = document.getElementById("divided-bottom-section");

          // Hide UI control elements within divided-top-section
          const uiElements = [
            'new-top-layer',                    // Navigation and control buttons
            'inner-charms-control-layer',       // Inner charm controls
            'glitter-control-layer',            // Glitter controls
            'option-list-control-layer',        // Option list controls
            'option-text-field-control-layer',  // Text field controls
            'photo-controls-layer',            // Photo controls
            'dots-container'                    // Dot indicators
          ];

          // Hide all UI elements
          [middleSection, bottomSection].forEach(el => {
            if (el && el.style.display !== 'none') {
              elementsToHide.push({ element: el, originalDisplay: el.style.display || '' });
              el.style.display = 'none';
            }
          });

          uiElements.forEach(id => {
            const el = document.getElementById(id);
            if (el && el.style.display !== 'none') {
              elementsToHide.push({ element: el, originalDisplay: el.style.display || '' });
              el.style.display = 'none';
            }
          });

          // Hide charm control buttons (delete, rotate buttons)
          const charmControls = target.querySelectorAll('.delete-button, .rotate-button, .inner-charm-delete-btn, .inner-charm-rotate-btn, .inner-charm-controls');
          charmControls.forEach(el => {
            if (el && el.style.display !== 'none') {
              elementsToHide.push({ element: el, originalDisplay: el.style.display || '' });
              el.style.display = 'none';
            }
          });

          // Wait a moment for DOM to update
          await new Promise(resolve => setTimeout(resolve, 100));

          console.log('✅ Capturing screenshot with html2canvas...');
          const canvas = await html2canvas(target, {
            backgroundColor: null,                // transparent background
            scale: window.devicePixelRatio || 2,  // higher quality
            useCORS: true,                        // attempt to load cross-origin images with CORS
            allowTaint: false,                    // keep false when using CORS
            logging: false,
            ignoreElements: (el) => {
              // ❌ Remove outer charms (.placed-charm) but keep inner charms (.placed-inner-charm)
              if (el.classList?.contains('placed-charm') && !el.classList?.contains('placed-inner-charm')) {
                return true; // Ignore outer charms
              }
              if (el.closest?.('.placed-charm') && !el.closest?.('.placed-inner-charm')) {
                return true; // Ignore elements inside outer charms
              }

              // ❌ Hide UI control elements
              if (el.id === 'new-top-layer' ||
                  el.id === 'inner-charms-control-layer' ||
                  el.id === 'glitter-control-layer' ||
                  el.id === 'option-list-control-layer' ||
                  el.id === 'option-text-field-control-layer' ||
                  el.id === 'photo-controls-layer' ||
                  el.id === 'dots-container' ||
                  el.classList?.contains('delete-button') ||
                  el.classList?.contains('rotate-button') ||
                  el.classList?.contains('inner-charm-delete-btn') ||
                  el.classList?.contains('inner-charm-rotate-btn') ||
                  el.classList?.contains('inner-charm-controls')) {
                return true;
              }

              // ✅ KEEP inner charms
              if (el.classList?.contains('placed-inner-charm')) return false;
              if (el.closest?.('.placed-inner-charm')) return false;

              // ❌ ignore Shopify + custom elements
              return (
                el.tagName?.includes('-') ||
                el.closest?.('[data-shopify]')
              );
            },
            // ---- MODIFY CLONE ONLY ----
            onclone: (doc) => {
              // Remove outer charms from the cloned document
              doc.querySelectorAll('.placed-charm').forEach(el => {
                // Only remove if it's NOT an inner charm
                if (!el.classList.contains('placed-inner-charm')) {
                  el.remove();
                }
              });

              // Remove UI control elements from cloned document
              const uiIds = ['new-top-layer', 'inner-charms-control-layer', 'glitter-control-layer',
                            'option-list-control-layer', 'option-text-field-control-layer',
                            'photo-controls-layer', 'dots-container'];
              uiIds.forEach(id => {
                const el = doc.getElementById(id);
                if (el) el.remove();
              });

              // Remove control buttons
              doc.querySelectorAll('.delete-button, .rotate-button, .inner-charm-delete-btn, .inner-charm-rotate-btn, .inner-charm-controls').forEach(el => {
                el.remove();
              });

              // Ensure inner charms stay visible
              doc.querySelectorAll('.placed-inner-charm').forEach(el => {
                el.style.visibility = 'visible';
                el.style.opacity = '1';
              });

              // Fix protocol-relative images
              doc.querySelectorAll('img').forEach(img => {
                if (img.src.startsWith('//')) {
                  img.src = window.location.protocol + img.src;
                }
              });
            }
          });

          // Restore all hidden elements
          elementsToHide.forEach(({ element, originalDisplay }) => {
            element.style.display = originalDisplay;
          });

          // Convert canvas to base64 and store
          const screenshotBase64 = canvas.toDataURL('image/png');
          localStorage.setItem('locketScreenshot', screenshotBase64);
          locketScreenshot = screenshotBase64;
          console.log('✅ Screenshot captured and stored');
        }
      } catch (error) {
        console.error('❌ Error capturing screenshot:', error);
        // Continue even if screenshot fails
      }
    }
    
    // Add custom text to properties if exists
    if (customText) {
      locketProperties['_Custom Text'] = customText;
      locketProperties['Name'] = customText; // Visible version
    }
    
    // Add photo info to properties if exists
    if (uploadedPhoto) {
      locketProperties['_Has Photo'] = 'Yes';
      locketProperties['Custom Photo'] = 'Uploading...';
      
      // Upload photo to ImgBB to get a URL
      updateButtonProgress('Uploading photo...');
      console.log('📤 Uploading custom photo...');
      const photoUpload = await uploadImageToImgBB(uploadedPhoto);
      
      if (photoUpload && photoUpload.url) {
        // Success! Store the URL instead of base64
        locketProperties['_Photo URL'] = photoUpload.url;
        locketProperties['_Photo Thumbnail'] = photoUpload.thumb_url;
        locketProperties['_Photo Medium'] = photoUpload.medium_url;
        locketProperties['_Delete URL'] = photoUpload.delete_url; // For admin use
        locketProperties['Custom Photo'] = photoUpload.url; // Visible URL
        locketProperties['Photo Preview'] = photoUpload.medium_url; // For display
        console.log('✅ Photo uploaded and URL stored');
      } else {
        // Upload failed - store a note
        console.warn('⚠️ Photo upload failed, storing reference only');
        locketProperties['Photo Note'] = 'Photo upload failed - Please contact support';
        // Keep photo in localStorage as backup
        localStorage.setItem('locketPhotoBackup', uploadedPhoto);
      }
    }

      // Add locket preview screenshot info if exists
      if (locketScreenshot) {
        // Upload screenshot to ImgBB to get a URL
        updateButtonProgress('Uploading Preview...');
        console.log('📤 Uploading locket preview screenshot...');
        const locketScreenshotUpload = await uploadImageToImgBB(locketScreenshot);
        if (locketScreenshotUpload && locketScreenshotUpload.url) {
          locketProperties['_Locket Preview URL'] = locketScreenshotUpload.url;
          locketProperties['_Locket Preview Thumbnail'] = locketScreenshotUpload.thumb_url;
          locketProperties['_Locket Preview Medium'] = locketScreenshotUpload.medium_url;
          locketProperties['Locket Preview'] = locketScreenshotUpload.url;
          locketProperties['View Design'] = locketScreenshotUpload.url;
          locketProperties['Custom Locket Preview'] = locketScreenshotUpload.url; // Visible URL
          console.log('✅ Locket Preview uploaded and URL stored');
        } else {
          console.warn('⚠️ Locket Preview upload failed, storing reference only');
        }
      }

    // Add glitter info if exists
    if (selectedGlitter) {
        console.log('selectedGlitter:', selectedGlitter);
      try {
        const glitterDataJson = JSON.parse(selectedGlitter);
        locketProperties['Selected Glitter'] = glitterDataJson.name || 'Yes';
        locketProperties['Selected Glitter'] = glitterDataJson.name || 'Yes';
        console.log('glitterDataJson:', glitterDataJson);
        console.log('glitterDataJson.name:', glitterDataJson.name);

      } catch (e) {
        console.log('glitterDataJson Error', e);
        locketProperties['_Glitter'] = 'Yes';
        locketProperties['Glitter'] = 'Yes';
      }
    }
    
    // Add outer charms info
    if (outerCharms.length > 0) {
      locketProperties['_Outer Charms'] = outerCharms.length;
      locketProperties['Outer Frame Charms'] = `${outerCharms.length} charm${outerCharms.length > 1 ? 's' : ''}`;
    }
    
    // Add inner charms info
    if (innerCharms.length > 0) {
      locketProperties['_Inner Charms'] = innerCharms.length;
      locketProperties['Inside Charms'] = `${innerCharms.length} charm${innerCharms.length > 1 ? 's' : ''}`;
    }
    
    // Add summary description
    let summaryParts = [];
    if (customText) summaryParts.push('Custom Name');
    if (uploadedPhoto) summaryParts.push('Photo');
    if (locketScreenshot) summaryParts.push('Preview');
    if (outerCharms.length > 0) summaryParts.push(`${outerCharms.length} Outer Charm${outerCharms.length > 1 ? 's' : ''}`);
    if (innerCharms.length > 0) summaryParts.push(`${innerCharms.length} Inner Charm${innerCharms.length > 1 ? 's' : ''}`);
    if (selectedGlitter) summaryParts.push('Glitter');
    
    if (summaryParts.length > 0) {
      locketProperties['Customization'] = summaryParts.join(', ');
    }
    
    // Add the main locket to cart
    // Get the variant ID (use first variant or variants[0].id)
    const locketVariantId = selectedLocket.variants && selectedLocket.variants[0] 
      ? selectedLocket.variants[0].id 
      : selectedLocket.id;
    
    updateButtonProgress('Adding locket...');
    console.log('=== Adding Main Locket ===');
    console.log('Variant ID:', locketVariantId);
    console.log('Properties:', Object.keys(locketProperties));
    
    try {
      await addToCart(locketVariantId, 1, locketProperties);
      console.log('✅ Locket added successfully');
    } catch (error) {
      console.error('❌ Failed to add locket:', error);
      if (confirmBtn) {
        confirmBtn.disabled = false;
        confirmBtn.style.opacity = '1';
        confirmBtn.style.cursor = 'pointer';
        confirmBtn.textContent = originalBtnText;
      }
      const currentLang = localStorage.getItem('lang') || 'en';
      const currentTranslations = JSON.parse(localStorage.getItem('customLocketLocalization')) || {};
      const errorMsg = (currentTranslations[currentLang]?.error_adding_to_cart || 'Error adding locket to cart: {error}').replace('{error}', error.message);
      alert(errorMsg);
      throw error;
    }
    
    // ========================================
// BATCH ADD: Build items array for charms
// ========================================

const charmItemsToAdd = [];

// Collect all outer charms
for (let i = 0; i < outerCharms.length; i++) {
const charm = outerCharms[i];
if (charm.productInfo) {
const variantId = charm.productInfo.variants && charm.productInfo.variants[0]
? charm.productInfo.variants[0].id
: charm.productId;

if (variantId) {
charmItemsToAdd.push({
id: variantId,
quantity: 1,
properties: {
'_Type': 'Outer Charm',
'_Position': `Dot ${charm.dotIndex + 1}`,
'_For Locket': selectedLocket.title || 'Custom Locket',
'_Bundle ID': bundleId,
'_Locked': 'true',
'_Bundle Type': 'Custom Locket - Part',
'Position index': `Outer Frame - Spot ${charm.dotIndex + 1}`,
'Part of': 'Custom Locket Bundle',
'Locket Type what': selectedLocket.metafields?.dimension_description || 'Custom'
}
});
console.log(`✅ Added outer charm ${i + 1} to batch`);
}
}
}

// Collect all inner charms
for (let i = 0; i < innerCharms.length; i++) {
const charm = innerCharms[i];
if (charm.productInfo) {
const variantId = charm.productInfo.variants && charm.productInfo.variants[0]
? charm.productInfo.variants[0].id
: charm.productId;

if (variantId) {
charmItemsToAdd.push({
id: variantId,
quantity: 1,
properties: {
'_Type': 'Inner Charm',
'_Position': `${i + 1}`,
'_For Locket': selectedLocket.title || 'Custom Locket',
'_Bundle ID': bundleId,
'_Locked': 'true',
'_Bundle Type': 'Custom Locket - Part',
'Part of': 'Custom Locket Bundle',
'Position': `Inside Locket - Charm ${i + 1}`,
'Locket Type': selectedLocket.metafields?.dimension_description || 'Custom'
}
});
console.log(`✅ Added inner charm ${i + 1} to batch`);
}
}
}

// Add all charms in one request if any exist
if (charmItemsToAdd.length > 0) {
updateButtonProgress(`Adding ${charmItemsToAdd.length} charm${charmItemsToAdd.length > 1 ? 's' : ''}...`);
console.log(`=== Adding ${charmItemsToAdd.length} charms in batch ===`);

try {
const response = await fetch('/cart/add.js', {
method: 'POST',
headers: {
'Content-Type': 'application/json',
'Accept': 'application/json'
},
body: JSON.stringify({ items: charmItemsToAdd })
});

if (!response.ok) {
const errorText = await response.text();
throw new Error(`Failed to add charms: ${response.status} - ${errorText}`);
}

const result = await response.json();
console.log('✅ All charms added successfully:', result);

} catch (error) {
console.error('❌ Failed to add charms:', error);
throw error;
}
}
    
    console.log('=== All items added to cart successfully ===');
    
    // Screenshot was already captured and added to properties before adding to cart
    // If it wasn't captured earlier, try one more time as backup
    // const storedScreenshotURL = localStorage.getItem('locketScreenshotURL');
    // if (!storedScreenshotURL) {
    //   console.log('📸 Screenshot not found, attempting backup capture...');
    //   updateButtonProgress('Capturing preview...');
    //   const screenshotResult = await captureLocketPreviewScreenshot();
      
    //   if (screenshotResult && screenshotResult.url) {
    //     // Try to update the cart item as backup
    //     try {
    //       await new Promise(resolve => setTimeout(resolve, 1000));
    //       const cartResponse = await fetch('/cart.js');
    //       const cart = await cartResponse.json();
          
    //       let locketItem = null;
    //       for (let i = 0; i < cart.items.length; i++) {
    //         const item = cart.items[i];
    //         if (item.properties) {
    //           const hasLocked = item.properties.some(prop =>
    //             (prop.first === '_Locked' && prop.last === 'true')
    //           );
    //           if (hasLocked) {
    //             locketItem = item;
    //             break;
    //           }
    //         }
    //       }
          
    //       if (locketItem) {
    //         // Convert properties to array format (Shopify uses first/last)
    //         let existingProperties = [];
    //         if (Array.isArray(locketItem.properties)) {
    //           existingProperties = locketItem.properties.map(prop => ({
    //             first: prop.first || prop.name || '',
    //             last: prop.last || prop.value || ''
    //           }));
    //         }
            
    //         // Add screenshot properties
    //         const newProperties = [
    //           ...existingProperties.filter(p =>
    //             p.first !== 'Locket Preview' &&
    //             p.first !== 'View Design' &&
    //             p.first !== '_Locket Preview URL'
    //           ),
    //           { first: '_Locket Preview URL', last: screenshotResult.url },
    //           { first: 'Locket Preview', last: screenshotResult.url },
    //           { first: 'View Design', last: screenshotResult.url }
    //         ];
            
    //         const updates = {};
    //         updates[locketItem.key] = {
    //           quantity: locketItem.quantity,
    //           properties: newProperties
    //         };
            
    //         await fetch('/cart/update.js', {
    //           method: 'POST',
    //           headers: { 'Content-Type': 'application/json' },
    //           body: JSON.stringify({ updates: updates })
    //         });
            
    //         console.log('✅ Backup screenshot added to cart');
    //       }
    //     } catch (error) {
    //       console.error('❌ Backup screenshot update failed:', error);
    //     }
    //   }
    // } else {
    //   console.log('✅ Screenshot already in properties:', storedScreenshotURL);
    // }
    
    // Update cart
    updateButtonProgress('Finalizing...');
    await updateCartView();
    
    // Show success state briefly
updateButtonProgress('Success! ✓');
await new Promise(resolve => setTimeout(resolve, 500));

// Auto-reset and redirect to cart
resetJourney();
window.location.href = '/cart';

  } catch (error) {
    console.error('Error adding items to cart:', error);
    
    // Hide loading screen on error
    hideLoadingScreen();
    
    // Re-enable navigation next button on error
    const navArrow = document.getElementById('nav-arrow');
    if (navArrow) {
      navArrow.style.pointerEvents = 'auto';
      navArrow.style.opacity = '1';
      navArrow.style.cursor = 'pointer';
      navArrow.disabled = false;
      console.log('Navigation next button re-enabled due to error');
    }
    
    // Re-enable button on error
    if (confirmBtn) {
      confirmBtn.disabled = false;
      confirmBtn.style.opacity = '1';
      confirmBtn.style.cursor = 'pointer';
      confirmBtn.textContent = originalBtnText;
    }
    
    // Show detailed error message
    const currentLang = localStorage.getItem('lang') || 'en';
    const currentTranslations = JSON.parse(localStorage.getItem('customLocketLocalization')) || {};
    let errorMsg;
    if (error.message) {
      errorMsg = (currentTranslations[currentLang]?.error_adding_items_to_cart || 'There was an error adding items to cart:\n\n{error}').replace('{error}', error.message);
    } else {
      errorMsg = currentTranslations[currentLang]?.error_unknown || 'Unknown error. Please check console for details.';
    }
    
    alert(errorMsg);
  }
}

// Debug function to check cart contents
async function debugCart() {
  try {
    const cart = await fetch('/cart.js').then(r => r.json());
    console.log('=== CART DEBUG ===');
    console.log('Total items:', cart.item_count);
    console.log('Cart items:', cart.items);
    return cart;
  } catch (error) {
    console.error('Error fetching cart:', error);
  }
}

// Make debugCart available globally for testing
window.debugCart = debugCart;

var backstack = [];
var pagesNavHeaderText = [
    'Start',
     'Choose Your Lockets Size',
     'Design your lockets outer frame',
     'Choose what to put inside the locketpage-options',
     'Write your name',
     'Add photo inside',
     'Add charms inside',
     'Add Glitter inside',
     'page-end'
    ];

// ---------- PAGE STATE PRESERVATION ----------

/**
 * Save current page state to localStorage
 * This is called whenever the page state changes
 */
function savePageState() {
    try {
        // Get all pages and find which one is currently visible
        var allPages = document.querySelectorAll('.page');
        var visiblePage = null;
        var visibleOptionPage = null;
        
        allPages.forEach(function(page) {
            if (page && !page.classList.contains('hide')) {
                visiblePage = page.id;
            }
        });
        
        // Get all option pages and find which one is visible
        var optionListIds = [
            "option-list",
            "option-list-outer-charms",
            "option-list-inner-charms",
            "option-text-field",
            "option-photo",
            "option-list-gliter",
            "option-list-gliter-half"
        ];
        
        optionListIds.forEach(function(id) {
            var el = document.getElementById(id);
            if (el && !el.classList.contains('hide')) {
                visibleOptionPage = id;
                console.log('Found visible option page:', id);
            }
        });
        
        // Save navigation visibility
        var navigation = document.getElementById("navigation");
        var navTitle = document.getElementById("nav-title");
        var isNavigationVisible = navigation && !navigation.classList.contains('hide');
        var isNavTitleVisible = navTitle && !navTitle.classList.contains('hide');
        
        // Save current state
        var pageState = {
            visiblePage: visiblePage,
            visibleOptionPage: visibleOptionPage,
            isNavigationVisible: isNavigationVisible,
            isNavTitleVisible: isNavTitleVisible,
            timestamp: Date.now()
        };
        
        localStorage.setItem('pageState', JSON.stringify(pageState));
        console.log('Page state saved:', pageState);
    } catch (error) {
        console.error('Error saving page state:', error);
    }
}

// Make savePageState available globally
window.savePageState = savePageState;

/**
 * Restore option list content when restoring page state
 * This recreates the option items that were dynamically created
 */
function restoreOptionListContent() {
    try {
        var selectedLocket = JSON.parse(localStorage.getItem('selectedLocket'));
        if (!selectedLocket || !selectedLocket.metafields || !selectedLocket.metafields.locket_options) {
            console.warn('Cannot restore option list: selectedLocket or options not found');
            return;
        }
        
        var options = selectedLocket.metafields.locket_options;
        var optionHorizontalOptionsList = document.getElementById("option-list");
        
        if (!optionHorizontalOptionsList) {
            console.warn('option-list element not found');
            return;
        }
        
        console.log('Restoring option list content with', options.length, 'options');
        
        // Get current language and translations
        var currentLang = localStorage.getItem('lang') || 'en';
        var currentTranslations = JSON.parse(localStorage.getItem('customLocketLocalization')) || {};
        
        // Set instruction title
        var optionInstructionTitle = document.getElementById("option-instruction-title");
        if (optionInstructionTitle) {
            var titleText = currentTranslations[currentLang]?.option_list_page_title || translations[lang]?.option_list_page_title || "select the options that your go with!";
            setTextWithLineBreak(optionInstructionTitle, titleText);
        }
        
        // Clear any existing items
        optionHorizontalOptionsList.innerHTML = "";
        
        // Create and append new items from 'options'
        if (Array.isArray(options)) {
            options.forEach(function(option) {
                var item = document.createElement("div");
                item.className = "option-horiontal-options-list-item";
                if(option === 'Name & Charms'){
                    item.textContent = currentTranslations[currentLang]?.[`locket_options_name`] || translations[lang]?.[`locket_options_name`] || '';
                }else{
                    item.textContent = currentTranslations[currentLang]?.[`locket_options_${option.toLowerCase()}`] || translations[lang]?.[`locket_options_${option.toLowerCase()}`] || '';
                }
                item.onclick = function() {
                    handleOptionClick(option);
                };
    
                optionHorizontalOptionsList.appendChild(item);
            });
            
            console.log('Option list content restored with', options.length, 'items');
        }
        
        // Ensure it's visible
        optionHorizontalOptionsList.classList.remove("hide");
        optionHorizontalOptionsList.style.display = '';
        
        // Ensure page-outer-charm is visible
        var pageOuterCharm = document.getElementById('page-outer-charm');
        if (pageOuterCharm) {
            pageOuterCharm.classList.remove('hide');
        }
        
    } catch (error) {
        console.error('Error restoring option list content:', error);
    }
}

/**
 * Reset the entire journey - clears all saved state and returns to start
 */
function resetJourney() {
    try {
        // Clear all locket-related localStorage items
        localStorage.removeItem('selectedLocket');
        localStorage.removeItem('selectedItems');
        localStorage.removeItem('innerCharms');
        localStorage.removeItem('locketCustomText');
        localStorage.removeItem('uploadedPhoto');
        localStorage.removeItem('selectedGlitter');
        localStorage.removeItem('backstack');
        localStorage.removeItem('pageState');
        
        // Clear cached locket image and map data
        localStorage.removeItem('locketImageUrl');
        localStorage.removeItem('locketSize');
        localStorage.removeItem('locketCoords');
        localStorage.removeItem('locketOriginalWidth');
        localStorage.removeItem('locketOriginalHeight');
        
        // Clear screenshot data
        localStorage.removeItem('locketScreenshot');
        localStorage.removeItem('locketScreenshotSquare');
        localStorage.removeItem('locketScreenshotURL');
        localStorage.removeItem('locketScreenshotThumbnail');
        localStorage.removeItem('locketScreenshotMedium');
        localStorage.removeItem('locketScreenshotSquareURL');
        localStorage.removeItem('locketScreenshotSquareThumbnail');
        localStorage.removeItem('locketScreenshotSquareMedium');
        localStorage.removeItem('locketScreenshotTimestamp');
        // Show the "Show Your Locket" button after screenshot is cleared
        if (typeof updateShowPreviewButtonVisibility === 'function') {
          updateShowPreviewButtonVisibility();
        }
        localStorage.removeItem('locketPhotoBackup');
        
        // Reset backstack
        backstack = [];
        
        // Hide all pages
        var allPages = document.querySelectorAll('.page');
        allPages.forEach(function(page) {
            if (page) {
                page.classList.add('hide');
            }
        });
        
        // Hide all option pages
        var optionListIds = [
            "option-list",
            "option-list-outer-charms",
            "option-list-inner-charms",
            "option-text-field",
            "option-photo",
            "option-list-gliter",
            "option-list-gliter-half"
        ];
        optionListIds.forEach(function(id) {
            var el = document.getElementById(id);
            if (el) {
                el.classList.add('hide');
            }
        });
        
        // Show start page
        var pageStart = document.getElementById("page-start");
        if (pageStart) {
            pageStart.classList.remove('hide');
        }
        
        // Hide navigation
        var navigation = document.getElementById("navigation");
        var navTitle = document.getElementById("nav-title");
        if (navigation) {
            navigation.classList.add('hide');
        }
        if (navTitle) {
            navTitle.classList.add('hide');
        }
        
        // Clear dots container if it exists
        var dotsContainer = document.getElementById('dots-container');
        if (dotsContainer) {
            dotsContainer.innerHTML = '';
        }
        
        // Clear locket image
        var locketImage = document.getElementById('selected-locket-img');
        if (locketImage) {
            locketImage.src = '';
        }
        
        // Clear background image
        var backgroundImage = document.getElementById('background-image');
        if (backgroundImage) {
            backgroundImage.style.backgroundImage = '';
            backgroundImage.classList.remove('has-photo');
        }
        
        // Clear text overlay
        var textOverlay = document.getElementById('text-overlay');
        if (textOverlay) {
            textOverlay.textContent = '';
            textOverlay.style.clipPath = '';
        }
        
        // Clear text input
        var textInput = document.getElementById('locket-text-input');
        if (textInput) {
            textInput.value = '';
        }
        
        // Clear photo input
        var photoField = document.getElementById('option-photo-field');
        if (photoField) {
            photoField.value = '';
        }
        
        // Reset charmPlacedAt if it exists globally
        if (typeof window.charmPlacedAt !== 'undefined' && window.charmPlacedAt instanceof Set) {
            window.charmPlacedAt.clear();
        }
        
        // Hide locket preview and show sections if preview is currently shown
        hideLocketPreview();

        // Re-enable confirm button if it was disabled
        var confirmBtn = document.getElementById('confirm-selection-button');
        if (confirmBtn) {
            confirmBtn.disabled = false;
            confirmBtn.removeAttribute('disabled');
            confirmBtn.style.opacity = '1';
            confirmBtn.style.cursor = 'pointer';
            confirmBtn.style.pointerEvents = 'auto';
            // Reset button text if it was changed
            var currentLang = localStorage.getItem('lang') || 'en';
            var currentTranslations = JSON.parse(localStorage.getItem('customLocketLocalization')) || {};
            confirmBtn.textContent = currentTranslations[currentLang]?.confirm_selection_btn_label || 'Confirm Selection';
            // Ensure onclick handler is still attached
            if (!confirmBtn.onclick) {
                confirmBtn.setAttribute('onclick', 'confirmSelectionBtn()');
            }
        }

        // Re-enable navigation arrow if it was disabled
        var navArrow = document.getElementById('nav-arrow');
        if (navArrow) {
            navArrow.disabled = false;
            navArrow.removeAttribute('disabled');
            navArrow.style.pointerEvents = 'auto';
            navArrow.style.opacity = '1';
            navArrow.style.cursor = 'pointer';
        }

        // Hide confirm section since we're back at start page
        var dividedConfrimSection = document.querySelector(".divided-confrim-section");
        if (dividedConfrimSection) {
            dividedConfrimSection.classList.add('hide');
        }

        console.log('✅ Journey reset - all state cleared');

     // Don't show modal - silent reset
    return true;
    } catch (error) {
        console.error('Error resetting journey:', error);
        return false;
    }
}

// Make resetJourney available globally
window.resetJourney = resetJourney;

/**
 * Restore page state from localStorage
 * This is called when the page loads
 */
function restorePageState() {
    try {
        var savedState = localStorage.getItem('pageState');
        if (!savedState) {
            console.log('No saved page state found');
            return false;
        }
        
        var pageState = JSON.parse(savedState);
        console.log('Restoring page state:', pageState);
        
        // Check if backstack exists - if not, don't restore (user hasn't started flow)
        var savedBackstack = JSON.parse(localStorage.getItem('backstack') || '[]');
        if (!savedBackstack || savedBackstack.length === 0) {
            console.log('No backstack found, not restoring state');
            return false;
        }
        
        // Restore backstack
        backstack = savedBackstack;
        
        // Check if user is on preview locket page - if so, don't restore options
        var isOnPreviewPage = savedBackstack.length > 0 && savedBackstack[savedBackstack.length - 1] === "page-outer-charm:locket-screenshot";

        // Hide all pages first
        var allPages = document.querySelectorAll('.page');
        allPages.forEach(function(page) {
            if (page) {
                page.classList.add('hide');
            }
        });
        
        // Show the saved visible page
        if (pageState.visiblePage) {
            var pageElement = document.getElementById(pageState.visiblePage);
            if (pageElement) {
                pageElement.classList.remove('hide');
                console.log('Restored page:', pageState.visiblePage);
                
                // If restoring the outer charm page, restore locket image and dots
                if (pageState.visiblePage === 'page-outer-charm') {
                    setTimeout(function() {
                        if (typeof window.restoreLocketFromCache === 'function') {
                            var restored = window.restoreLocketFromCache();
                            if (restored) {
                                console.log('Locket restored from cache');
                                // Recreate outer charms list after locket is restored
                                setTimeout(function() {
                                    if (typeof window.createOuterCharmList === 'function') {
                                        window.createOuterCharmList();
                                        console.log('Outer charms list recreated after locket restore');
                                    }
                                }, 400);
                                // Wait a bit more for image to load
                                setTimeout(function() {
                                    waitForEverythingReady();
                                }, 500);
                            } else {
                                // Recreate outer charms list even if locket wasn't restored
                                setTimeout(function() {
                                    if (typeof window.createOuterCharmList === 'function') {
                                        window.createOuterCharmList();
                                        console.log('Outer charms list recreated');
                                    }
                                }, 400);
                                waitForEverythingReady();
                            }
                        } else {
                            // Recreate outer charms list
                            setTimeout(function() {
                                if (typeof window.createOuterCharmList === 'function') {
                                    window.createOuterCharmList();
                                    console.log('Outer charms list recreated');
                                }
                            }, 400);
                            waitForEverythingReady();
                        }
                    }, 300);
                    // Continue with restoration but mark that we're handling overlay separately
                    // We'll return true at the end, but overlay hiding is handled above
                }
            }
        }
        
        // Restore navigation visibility
        var navigation = document.getElementById("navigation");
        var navTitle = document.getElementById("nav-title");
        
        if (navigation) {
            if (pageState.isNavigationVisible) {
                navigation.classList.remove('hide');
            } else {
                navigation.classList.add('hide');
            }
        }
        
        if (navTitle) {
            if (pageState.isNavTitleVisible) {
                navTitle.classList.remove('hide');
            } else {
                navTitle.classList.add('hide');
            }
        }
        
        // Restore option page visibility - but skip if on preview page
        if (pageState.visibleOptionPage && !isOnPreviewPage) {
            var optionListIds = [
                "option-list",
                "option-list-outer-charms",
                "option-list-inner-charms",
                "option-text-field",
                "option-photo",
                "option-list-gliter",
                "option-list-gliter-half"
            ];
            
            optionListIds.forEach(function(id) {
                var el = document.getElementById(id);
                if (el) {
                    if (id === pageState.visibleOptionPage) {
                        el.classList.remove('hide');
                        // Update the control option page to set proper titles
                        controlOptionPage(id);
                        
                        // If restoring option-list, recreate the option items
                        if (id === "option-list") {
                            // Delay to ensure DOM is ready
                            setTimeout(function() {
                                restoreOptionListContent();
                            }, 200);
                        }

                        // If restoring option-list-outer-charms, recreate the outer charms list
                        if (id === "option-list-outer-charms") {
                            // Delay to ensure DOM is ready
                            setTimeout(function() {
                                if (typeof window.createOuterCharmList === 'function') {
                                    window.createOuterCharmList();
                                    console.log('Outer charms list recreated on page restore');
                                } else {
                                    console.warn('createOuterCharmList function not available');
                                }
                            }, 300);
                        }
                    } else {
                        el.classList.add('hide');
                    }
                }
            });
            
            // Update divided confirm section visibility
            var dividedConfrimSection = document.querySelector(".divided-confrim-section");
            if (dividedConfrimSection) {
                if (pageState.visibleOptionPage === "option-list") {
                    dividedConfrimSection.classList.add("hide");
                } else {
                    dividedConfrimSection.classList.remove("hide");
                }
            }
        }
        
        // If on preview page, show preview section and restore screenshot
        if (isOnPreviewPage) {
            // Check if screenshot exists in localStorage
            var savedScreenshot = localStorage.getItem('locketScreenshot');

            // If screenshot is missing or empty, go back to previous page
            if (!savedScreenshot || savedScreenshot.trim() === '') {
                console.log('Screenshot not found, navigating back from preview page');

                // Pop "page-outer-charm:locket-screenshot" from backstack
                if (backstack.length > 0 && backstack[backstack.length - 1] === "page-outer-charm:locket-screenshot") {
                    backstack.pop();
                    localStorage.setItem('backstack', JSON.stringify(backstack));
                }

                // Get the previous page from backstack
                if (backstack.length > 0) {
                    var previousPage = backstack[backstack.length - 1];
                    console.log('Navigating back to:', previousPage);

                    // Hide preview section if it exists
                    var previewSection = document.getElementById("preview-section");
                    if (previewSection) {
                        previewSection.classList.add("hide");
                        previewSection.style.display = "none";
                    }

                    // Navigate to the previous page based on what it is
                    if (previousPage === "page-outer-charm:option-photo") {
                        controlOptionPage("option-photo");
                    } else if (previousPage === "page-outer-charm:option-list-gliter") {
                        controlOptionPage("option-list-gliter");
                    } else if (previousPage === "page-outer-charm:option-list-gliter-half") {
                        controlOptionPage("option-list-gliter-half");
                    } else if (previousPage === "page-outer-charm:option-list-inner-charms") {
                        controlOptionPage("option-list-inner-charms");
                        // Update inner charm counter
                        setTimeout(function() {
                            if (typeof updateInnerCharmCounter === 'function') {
                                updateInnerCharmCounter();
                            }
                        }, 100);
                    } else if (previousPage === "page-outer-charm:option-text-field") {
                        controlOptionPage("option-text-field");
                    } else if (previousPage === "page-outer-charm:option-list") {
                        // Show option list
                        var optionList = document.getElementById("option-list");
                        var dividedConfrimSection = document.querySelector(".divided-confrim-section");
                        if (optionList) {
                            optionList.classList.remove('hide');
                        }
                        if (dividedConfrimSection) {
                            dividedConfrimSection.classList.add('hide');
                        }
                        // Restore option list content
                        setTimeout(function() {
                            restoreOptionListContent();
                        }, 200);
                    }

                    // Show and enable navigation buttons when navigating back from preview
                    const navArrow = document.getElementById("nav-arrow");
                    const navArrowReverse = document.getElementById("nav-arrow-reverse");
                    if(navArrow) {
                        navArrow.style.display = "";
                        navArrow.disabled = false;
                        navArrow.style.pointerEvents = "auto";
                    }
                    if(navArrowReverse) {
                        navArrowReverse.style.display = "";
                        navArrowReverse.disabled = false;
                        navArrowReverse.style.pointerEvents = "auto";
                    }

                    // Update nav title
                    setTimeout(updateNavTitle, 100);
                    // Save state after navigating back
                    setTimeout(savePageState, 100);

                    console.log('Navigated back from preview page - screenshot was missing');
                    return true;
                }
            } else {
                // Screenshot exists, show preview page normally
                // Remove all sections that should be hidden on preview page
                var topSection = document.getElementById("divided-top-section");
                var middleSection = document.getElementById("divided-middle-section");
                var bottomSection = document.getElementById("divided-bottom-section");
                var confirmSelectionSection = document.getElementById("divided-confrim-section");

                // Remove controls
                var innerCharmControls = document.getElementById("inner-charm-controls");
                var outerCharmControls = document.getElementById("outer-charm-controls");
                var glitterControls = document.getElementById("glitter-control-layer");
                var photoControls = document.getElementById("photo-controls-layer");
                var textFieldControls = document.getElementById("text-field-controls");
                var optionListControls = document.getElementById("option-list-controls");
                var optionListInnerCharmsControls = document.getElementById("option-list-inner-charms-controls");
                var optionListOuterCharmsControls = document.getElementById("option-list-outer-charms-controls");

                if (topSection) {
                    topSection.remove();
                }
                if (middleSection) {
                    middleSection.remove();
                }
                if (bottomSection) {
                    bottomSection.remove();
                }
                if (confirmSelectionSection) {
                    confirmSelectionSection.remove();
                }
                if (innerCharmControls) {
                    innerCharmControls.remove();
                }
                if (outerCharmControls) {
                    outerCharmControls.remove();
                }
                if (glitterControls) {
                    glitterControls.remove();
                }
                if (photoControls) {
                    photoControls.remove();
                }
                if (textFieldControls) {
                    textFieldControls.remove();
                }
                if (optionListControls) {
                    optionListControls.remove();
                }
                if (optionListInnerCharmsControls) {
                    optionListInnerCharmsControls.remove();
                }
                if (optionListOuterCharmsControls) {
                    optionListOuterCharmsControls.remove();
                }

                var previewSection = document.getElementById("preview-section");
                var locketScreenshot = document.getElementById("locket-screenshot");

                if (previewSection) {
                    previewSection.classList.remove("hide");
                    previewSection.style.display = "flex";
                    previewSection.style.justifyContent = "center";
                    previewSection.style.alignItems = "center";
                    previewSection.style.position = "relative";
                    previewSection.style.zIndex = "9000";
                }

                // Ensure screenshot container is visible
                const screenshotContainer = document.querySelector('.locket-screenshot-container');
                if(screenshotContainer) {
                    screenshotContainer.style.display = "flex";
                }

                // Restore saved screenshot
                if (locketScreenshot) {
                    locketScreenshot.src = savedScreenshot;
                    locketScreenshot.style.display = "block";
                }

                // Show hint text when preview section is displayed
                const previewHintText = document.getElementById("preview-hint-text");
                if(previewHintText) {
                    previewHintText.classList.remove('hide');
                }

                // Hide and disable navigation buttons on preview page
                const navArrow = document.getElementById("nav-arrow");
                const navArrowReverse = document.getElementById("nav-arrow-reverse");
                if(navArrow) {
                    navArrow.style.display = "none";
                    navArrow.disabled = true;
                    navArrow.style.pointerEvents = "none";
                }
                if(navArrowReverse) {
                    navArrowReverse.style.display = "none";
                    navArrowReverse.disabled = true;
                    navArrowReverse.style.pointerEvents = "none";
                }

                console.log('Preview page restored - options not restored, sections removed');
            }
        }

        // Update nav title after restoring page state
        setTimeout(updateNavTitle, 100);
        
        console.log('Page state restored successfully');
        return true;
    } catch (error) {
        console.error('Error restoring page state:', error);
        return false;
    }
}

// Save page state whenever navigation changes
// We'll hook into existing navigation functions to auto-save
var originalShowPage = showPage;
var originalHidePage = hidePage;
var originalControlOptionPage = controlOptionPage;

// Function to update nav-title based on current page/state
/**
 * Update navigation button to show "Done" if next step is add to cart
 */
function updateNavButton() {
    var navArrow = document.getElementById("nav-arrow");
    if (!navArrow) return;
    
    var backstack = JSON.parse(localStorage.getItem('backstack')) || [];
    var currentPageId = backstack.length > 0 ? backstack[backstack.length - 1] : null;
    
    // Determine if next step is add to cart
    // This happens when clicking next will trigger confirmSelectionBtn() which then calls addAllItemsToCart()
    // Based on confirmSelectionBtn() logic: if backstack includes "page-outer-charm:option-list" 
    // and last item is one of the final steps, it calls addAllItemsToCart()
    var isNextStepAddToCart = false;
    
    // Check if backstack includes "page-outer-charm:option-list" (required condition)
    if (backstack.includes("page-outer-charm:option-list")) {
        // Check if current backstack item is one that triggers add to cart
        if (currentPageId === "page-outer-charm:option-photo" || 
            currentPageId === "page-outer-charm:option-list-gliter" || 
            currentPageId === "page-outer-charm:option-list-gliter-half") {
            isNextStepAddToCart = true;
        }
    }
    
    // Update button appearance
    var navigation = document.getElementById("navigation");
    var doneBtnUrl = navigation ? navigation.getAttribute("data-done-btn") : null;
    var arrowIconUrl = navigation ? navigation.getAttribute("data-arrow-icon") : null;
    
    if (isNextStepAddToCart && doneBtnUrl) {
        // Show "Done" button - make it 1.5x larger
        navArrow.style.background = 'url("' + doneBtnUrl + '") no-repeat center center';
        navArrow.style.backgroundSize = 'contain';
        navArrow.style.width = '60px'; // 40px * 1.5 = 60px
        navArrow.style.height = '60px'; // 40px * 1.5 = 60px
        navArrow.style.cursor = 'pointer'; // Ensure cursor is pointer
        navArrow.style.pointerEvents = 'auto'; // Ensure button is clickable
        navArrow.disabled = false; // Ensure button is not disabled
        navArrow.classList.add('done-button');
        console.log('Navigation button updated to "Done" - next step is add to cart');
    } else {
        // Show arrow button - reset to original size
        if (arrowIconUrl) {
            navArrow.style.background = 'url("' + arrowIconUrl + '") no-repeat center center';
        }
        navArrow.style.backgroundSize = 'contain';
        navArrow.style.width = '40px'; // Reset to original size
        navArrow.style.height = '40px'; // Reset to original size
        navArrow.style.cursor = 'pointer'; // Ensure cursor is pointer
        navArrow.style.pointerEvents = 'auto'; // Ensure button is clickable
        navArrow.classList.remove('done-button');
    }
}

function updateNavTitle() {
    var navTitle = document.getElementById("nav-title");
    if (!navTitle) return;
    
    var currentLang = localStorage.getItem('lang') || 'en';
    var currentTranslations = JSON.parse(localStorage.getItem('customLocketLocalization')) || {};
    var backstack = JSON.parse(localStorage.getItem('backstack')) || [];
    var currentPageId = backstack.length > 0 ? backstack[backstack.length - 1] : null;
    console.log('currentPageId', currentPageId);
    // Check which option page is currently visible
    var optionListIds = [
        "option-list",
        "option-list-outer-charms",
        "option-list-inner-charms",
        "option-text-field",
        "option-photo",
        "option-list-gliter",
        "option-list-gliter-half",
        "preview-section"
    ];
    
    var visibleOptionPage = null;
    optionListIds.forEach(function(id) {
        var el = document.getElementById(id);
        console.log('visibleOptionPage found', id);

        if (el && !el.classList.contains('hide')) {
            console.log('visibleOptionPage found', id);
            visibleOptionPage = id;
        }
    });
    
    // Update title based on visible option page or backstack
    if (visibleOptionPage) {
        console.log('visibleOptionPage found', visibleOptionPage);
        switch(visibleOptionPage) {
            case "option-list-outer-charms":
                navTitle.innerText = currentTranslations[currentLang]?.locket_options_outer_frame_title || translations[currentLang]?.locket_options_outer_frame_title || '';
                break;
            case "option-list-inner-charms":
                navTitle.innerText = currentTranslations[currentLang]?.locket_options_inner_frame_title || translations[currentLang]?.locket_options_inner_frame_title || '';
                break;
            case "option-list-gliter":
            case "option-list-gliter-half":
                navTitle.innerText = currentTranslations[currentLang]?.locket_options_glitter_title || translations[currentLang]?.locket_options_glitter_title || '';
                break;
            case "option-text-field":
                navTitle.innerText = currentTranslations[currentLang]?.locket_options_name_title || translations[currentLang]?.locket_options_name_title || '';
                break;
            case "option-photo":
                navTitle.innerText = currentTranslations[currentLang]?.locket_options_photo_title || translations[currentLang]?.locket_options_photo_title || '';
                break;
            case "option-list":
                // Option list title is set in confirmSelectionBtn, but we can set a default
                navTitle.innerText = currentTranslations[currentLang]?.option_list_page_title || translations[currentLang]?.option_list_page_title || '';
                break;
        case "preview-section":
            // Option list title is set in confirmSelectionBtn, but we can set a default
            navTitle.innerText = currentTranslations[currentLang]?.preivew_your_locket ||'';
            break;
        }
    } else if (currentPageId) {
        // Update based on backstack if no option page is visible
        if (currentPageId === "page-locket") {
            navTitle.innerText = translations[currentLang]?.locket_title || '';
        } else if (currentPageId === "page-outer-charm") {
            navTitle.innerText = currentTranslations[currentLang]?.outer_charm_page_title || translations[currentLang]?.outer_charm_page_title || '';
        } else if (currentPageId === "page-start") {
            navTitle.innerText = currentTranslations[currentLang]?.start_page_title || translations[currentLang]?.start_page_title || '';
        } else if (currentPageId === "page-end") {
            navTitle.innerText = currentTranslations[currentLang]?.end_page_title || translations[currentLang]?.end_page_title || '';
        }
    }
    
    // Update navigation button state
    updateNavButton();
    
    console.log('Nav title updated to:', navTitle.innerText, 'for page:', currentPageId, 'visible option:', visibleOptionPage);
}

// Override showPage to save state
function showPage(page) {
    if (typeof page === 'string') {
        var pageElement = document.getElementById(page);
        if (pageElement) {
            pageElement.classList.remove('hide');
            // If showing start page, ensure PDF modal listeners are set up
            if (page === 'page-start' || pageElement.id === 'page-start') {
                setTimeout(setupPdfModalListeners, 100);
            }
        }
    } else if (page && page.classList) {
        page.classList.remove('hide');
        // If showing start page, ensure PDF modal listeners are set up
        if (page.id === 'page-start') {
            setTimeout(setupPdfModalListeners, 100);
        }
    }
    // Update nav title when page changes
    setTimeout(updateNavTitle, 50);
    // Save state after showing page
    setTimeout(savePageState, 100);
}

// Override hidePage to save state
function hidePage(page) {
    if (page && page.classList) {
        page.classList.add('hide');
    }
    // Update nav title when page changes
    setTimeout(updateNavTitle, 50);
    // Save state after hiding page
    setTimeout(savePageState, 100);
}

// Override controlOptionPage to save state
function controlOptionPage(pageId) {
    console.log('controlOptionPage',pageId);
    // Get current language and translations dynamically
    var currentLang = localStorage.getItem('lang') || 'en';
    var currentTranslations = JSON.parse(localStorage.getItem('customLocketLocalization')) || {};
    
    // List of all option list element IDs
    var optionListIds = [
        "option-list",
        "option-list-outer-charms",
        "option-list-inner-charms",
        "option-text-field",
        "option-photo",
        "option-list-gliter",
        "option-list-gliter-half"
    ];

    optionListIds.forEach(function(id) {
        var el = document.getElementById(id);
        if (!el) {
            console.warn('Element not found:', id);
            return;
        }
        if (id === pageId) {
            el.classList.remove("hide");
            console.log('Showing option page:', id, 'has hide class:', el.classList.contains('hide'));
            // Force display if needed (in case CSS is overriding)
            if (el.classList.contains('hide')) {
                console.warn('Warning: Element still has hide class after removal:', id);
                el.style.display = '';
                el.classList.remove("hide");
            }
        } else {
            el.classList.add("hide");
        }
    });
    
    var optionHint = document.getElementById("option-instruction-title");
    var navTitle = document.getElementById("nav-title");

    
    switch(pageId){
        case "option-list-outer-charms":
            if (navTitle) navTitle.innerText = currentTranslations[currentLang]?.locket_options_outer_frame_title || translations[lang]?.locket_options_outer_frame_title || '';
            if (optionHint) setTextWithLineBreak(optionHint, currentTranslations[currentLang]?.locket_options_outer_frame_helper || translations[lang]?.locket_options_outer_frame_helper || '');
            // Ensure outer charm list is created when navigating to this option
            setTimeout(function() {
                if (typeof window.createOuterCharmList === 'function') {
                    window.createOuterCharmList();
                    console.log('Outer charm list created when navigating to outer charms option');
                }
            }, 100);
            break;
        case "option-list-inner-charms":
            if (navTitle) navTitle.innerText = currentTranslations[currentLang]?.locket_options_inner_frame_title || translations[lang]?.locket_options_inner_frame_title || '';
            if (optionHint) setTextWithLineBreak(optionHint, currentTranslations[currentLang]?.locket_options_inner_frame_helper || translations[lang]?.locket_options_inner_frame_helper || '');
            // Ensure inner charm list is created when navigating to this option
            setTimeout(function() {
                if (typeof window.createInnerCharmList === 'function') {
                    window.createInnerCharmList();
                    console.log('Inner charm list initialized when navigating to inner charms option');
                }
            }, 100);
            break;
        case "option-list-gliter":  
            if (navTitle) navTitle.innerText = currentTranslations[currentLang]?.locket_options_glitter_title || translations[lang]?.locket_options_glitter_title || '';
            if (optionHint) setTextWithLineBreak(optionHint, currentTranslations[currentLang]?.locket_options_glitter_helper || translations[lang]?.locket_options_glitter_helper || '');
            break;
        case "option-list-gliter-half":
            if (navTitle) navTitle.innerText = currentTranslations[currentLang]?.locket_options_glitter_title || translations[lang]?.locket_options_glitter_title || '';
            if (optionHint) setTextWithLineBreak(optionHint, currentTranslations[currentLang]?.locket_options_glitter_helper || translations[lang]?.locket_options_glitter_helper || '');
            break;
        case "option-text-field":
            if (navTitle) navTitle.innerText = currentTranslations[currentLang]?.locket_options_name_title || translations[lang]?.locket_options_name_title || '';
            if (optionHint) setTextWithLineBreak(optionHint, currentTranslations[currentLang]?.locket_options_name_helper || translations[lang]?.locket_options_name_helper || '');
            break;
        case "option-photo":
            if (navTitle) navTitle.innerText = currentTranslations[currentLang]?.locket_options_photo_title || translations[lang]?.locket_options_photo_title || '';
            if (optionHint) setTextWithLineBreak(optionHint, currentTranslations[currentLang]?.locket_options_photo_helper || translations[lang]?.locket_options_photo_helper || '');
            break;
        case "option-list":
        default:
            // For option-list, we don't need to set titles here
            // They are set in confirmSelectionBtn
            break;
    }

    var dividedConfrimSection = document.querySelector(".divided-confrim-section");
    if (dividedConfrimSection) {
        if(pageId === "option-list"){
            dividedConfrimSection.classList.add("hide");
        }else{
            dividedConfrimSection.classList.remove("hide");
        }
    }
    
    // Update nav title after option page change
    setTimeout(updateNavTitle, 50);
    
    // Save state after changing option page
    setTimeout(savePageState, 100);
}

// ---------- LOADING OVERLAY MANAGEMENT ----------

/**
 * Show loading overlay
 */
function showLoadingOverlay() {
    var loadingOverlay = document.getElementById('loading-overlay');
    if (loadingOverlay) {
        loadingOverlay.classList.remove('hide');
        console.log('Loading overlay shown');
    }
}

/**
 * Hide loading overlay
 */
function hideLoadingOverlay() {
    var loadingOverlay = document.getElementById('loading-overlay');
    if (loadingOverlay) {
        loadingOverlay.classList.add('hide');
        console.log('Loading overlay hidden');
    }
}

/**
 * Check if all critical elements are ready
 */
function checkElementsReady() {
    var criticalElements = [
        'main-container',
        'page-start',
        'page-locket',
        'page-outer-charm',
        'navigation',
        'nav-title'
    ];
    
    var allReady = true;
    criticalElements.forEach(function(id) {
        var element = document.getElementById(id);
        if (!element) {
            console.warn('Critical element not found:', id);
            allReady = false;
        }
    });
    
    return allReady;
}

/**
 * Wait for all elements and data to be ready before hiding loading overlay
 */
function waitForEverythingReady() {
    var maxWaitTime = 10000; // 10 seconds max
    var startTime = Date.now();
    var checkInterval = 100; // Check every 100ms
    
    function checkReady() {
        var elapsed = Date.now() - startTime;
        
        // Check if critical elements exist
        var elementsReady = checkElementsReady();
        
        // Check if translations are loaded (if needed)
        var translationsReady = true;
        try {
            var lang = localStorage.getItem('lang') || 'en';
            var translations = JSON.parse(localStorage.getItem('customLocketLocalization')) || {};
            // Translations are optional, so we don't fail if they're not loaded
        } catch (e) {
            console.warn('Error checking translations:', e);
        }
        
        // Check if DOM is fully loaded
        var domReady = document.readyState === 'complete' || document.readyState === 'interactive';
        
        if (elementsReady && domReady) {
            // Wait a bit more for any async operations
            setTimeout(function() {
                hideLoadingOverlay();
                console.log('Everything ready, loading overlay hidden');
            }, 300);
            return true;
        }
        
        // If we've waited too long, hide anyway
        if (elapsed >= maxWaitTime) {
            console.warn('Max wait time reached, hiding loading overlay anyway');
            hideLoadingOverlay();
            return true;
        }
        
        // Check again
        setTimeout(checkReady, checkInterval);
        return false;
    }
    
    checkReady();
}

// Initialize page state restoration on page load
function initializePageStateRestoration() {
    // Show loading overlay immediately
    showLoadingOverlay();
    
        // Wait a bit for all elements to be ready
        setTimeout(function() {
            var restored = restorePageState();
            if (restored) {
                console.log('Page state restored on load');
                // If we're restoring the outer charm page, waitForEverythingReady will be called from restorePageState
                // Check if we need to wait (outer charm restoration handles it)
                var outerCharmPage = document.getElementById('page-outer-charm');
                if (outerCharmPage && !outerCharmPage.classList.contains('hide')) {
                    // Outer charm page restoration will handle hiding overlay
                    // Don't call waitForEverythingReady here, it will be called from restorePageState
                    return;
                }
            }
            
            // Wait for everything to be ready before hiding overlay
            waitForEverythingReady();
        }, 100);
}

// Initialize button labels with translations
function initializeButtonLabels() {
    const currentLang = localStorage.getItem('lang') || 'en';
    const currentTranslations = JSON.parse(localStorage.getItem('customLocketLocalization')) || {};
    
    // Set confirm selection button label
    var confirmBtn = document.getElementById("confirm-selection-button");
    if (confirmBtn) {
        confirmBtn.textContent = currentTranslations[currentLang]?.confirm_selection_btn_label || 'Confirm Selection';
    }
    
    // Set reset button label
    var resetBtn = document.getElementById("reset-journey-btn");
    if (resetBtn) {
        resetBtn.textContent = currentTranslations[currentLang]?.reset_button_label || 'Reset';
    }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
        initializePageStateRestoration();
        initializeButtonLabels();
    });
} else {
    // DOM already loaded, but still show loading overlay
    initializePageStateRestoration();
    initializeButtonLabels();
}

// Also hide loading overlay when window is fully loaded
window.addEventListener('load', function() {
    setTimeout(function() {
        hideLoadingOverlay();
    }, 500);
});

// Also save state before page unload (as backup)
window.addEventListener('beforeunload', function() {
    savePageState();
});

// Event Listener
startBtn.addEventListener("click", function(){
    startFlow();
    // createLocketCards();
});

// ---------- PDF MODAL FUNCTIONS ----------

// Help PDF Modal functionality - get elements dynamically since they may not exist initially
// Get PDF URL from customLocketLocalization
function getPdfUrl() {
    const currentLang = localStorage.getItem('lang') || 'en';
    const currentTranslations = JSON.parse(localStorage.getItem('customLocketLocalization')) || {};
    
    // Debug logging
    console.log('=== PDF URL Debug (js-page-navigation.js) ===');
    console.log('Current language:', currentLang);
    console.log('Current translations:', currentTranslations);
    console.log('Current lang translations:', currentTranslations[currentLang]);
    console.log('help-pdf-link in current lang:', currentTranslations[currentLang]?.['help-pdf-link']);
    console.log('help-pdf-link in en:', currentTranslations['en']?.['help-pdf-link']);
    console.log('help-pdf-link at root:', currentTranslations['help-pdf-link']);
    
    // Try to get PDF URL - check both nested under language and at root level
    const pdfUrl = currentTranslations[currentLang]?.['help-pdf-link'] || 
                   currentTranslations['en']?.['help-pdf-link'] || 
                   currentTranslations['help-pdf-link'] ||
                   "https://cdn.shopify.com/s/files/1/0678/3457/7058/files/Manuel_memory.pdf?v=1764706677";
    
    console.log('Final PDF URL:', pdfUrl);
    console.log('===========================================');
    
    return pdfUrl;
}

// Helper function to get PDF modal elements
function getPdfModalElements() {
    return {
        modal: document.getElementById('help-pdf-modal'),
        close: document.getElementById('help-pdf-modal-close'),
        overlay: document.querySelector('.help-pdf-modal-overlay'),
        container: document.getElementById('help-pdf-container')
    };
}

// Function to render all pages of the PDF
function renderAllPages(pdf) {
    var elements = getPdfModalElements();
    if (!elements.container) return;
    
    elements.container.innerHTML = ''; // Clear container
    
    for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
        pdf.getPage(pageNum).then(function(page) {
            const viewport = page.getViewport({ scale: 1.5 });
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            canvas.style.display = 'block';
            canvas.style.margin = '0 auto 20px auto';
            canvas.style.maxWidth = '100%';
            canvas.style.height = 'auto';
            
            elements.container.appendChild(canvas);
            
            const renderContext = {
                canvasContext: context,
                viewport: viewport
            };
            
            page.render(renderContext);
        }).catch(function(error) {
            console.error('Error rendering page ' + pageNum + ':', error);
        });
    }
}

// Function to load and render PDF
function loadPdf() {
    var elements = getPdfModalElements();
    if (!elements.container) return;
    
    if (typeof pdfjsLib === 'undefined') {
        elements.container.innerHTML = '<p style="padding: 20px; text-align: center; color: #dc2626;">PDF viewer is loading. Please wait...</p>';
        // Wait for PDF.js to load
        setTimeout(function() {
            loadPdf();
        }, 200);
        return;
    }
    
    elements.container.innerHTML = '<p style="padding: 20px; text-align: center;">Loading PDF...</p>';
    
    pdfjsLib.getDocument(getPdfUrl()).promise.then(function(pdf) {
        renderAllPages(pdf);
    }).catch(function(error) {
        console.error('Error loading PDF:', error);
        var elements = getPdfModalElements();
        if (elements.container) {
            elements.container.innerHTML = '<p style="padding: 20px; text-align: center; color: #dc2626;">Error loading PDF. Please try again later.</p>';
        }
    });
}

// Function to open the PDF modal
function openHelpModal() {
    var elements = getPdfModalElements();
    if (elements.modal && elements.container) {
        elements.modal.style.display = 'flex';
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
        
        // Load PDF
        loadPdf();
    }
}

// Function to close the PDF modal
function closeHelpModal() {
    var elements = getPdfModalElements();
    if (elements.modal) {
        elements.modal.style.display = 'none';
        if (elements.container) {
            elements.container.innerHTML = '';
        }
        document.body.style.overflow = ''; // Restore scrolling
    }
}

// Setup PDF modal listeners
var pdfModalEscListenerSetup = false;
function setupPdfModalListeners() {
    // Close modal when ESC key is pressed (only add once)
    if (!pdfModalEscListenerSetup) {
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') {
                var elements = getPdfModalElements();
                if (elements.modal && elements.modal.style.display === 'flex') {
                    closeHelpModal();
                }
            }
        });
        pdfModalEscListenerSetup = true;
    }
    
    // Setup button listeners when elements are available
    var elements = getPdfModalElements();
    
    // Close modal when close button is clicked
    if (elements.close && !elements.close.hasAttribute('data-pdf-listener-attached')) {
        elements.close.addEventListener('click', function(e) {
            e.stopPropagation();
            closeHelpModal();
        });
        elements.close.setAttribute('data-pdf-listener-attached', 'true');
    }

    // Close modal when overlay is clicked
    if (elements.overlay && !elements.overlay.hasAttribute('data-pdf-listener-attached')) {
        elements.overlay.addEventListener('click', function(e) {
            e.stopPropagation();
            closeHelpModal();
        });
        elements.overlay.setAttribute('data-pdf-listener-attached', 'true');
    }
}

// Learn More button - opens PDF modal on start page, instruction modal elsewhere
var learnMoreBtn = document.getElementById("learn-more-btn");
if (learnMoreBtn) {
    learnMoreBtn.addEventListener("click", function(){
        // Check if we're on the start page (page-start is visible)
        var startPage = document.getElementById("page-start");
        if (startPage && !startPage.classList.contains("hide") && startPage.style.display !== "none") {
            // On start page - open PDF modal
            openHelpModal();
        } else {
            // On other pages - open instruction modal
            showInstructionModal();
        }
    });
}

// Setup PDF modal listeners
setupPdfModalListeners();

var helpBtnPaperBox = document.getElementById("help-btn-locket-page");
if (helpBtnPaperBox) {
    helpBtnPaperBox.addEventListener("click", function(){
        // This button is on the locket page - open PDF modal
        openHelpModal();
    });
}
//document.querySelector(".card-loc").addEventListener("click", function(){
 //   selectLocket();
//});

var navArrowReverse = document.getElementById("nav-arrow-reverse");
var navArrow = document.getElementById("nav-arrow");
var resetJourneyBtn = document.getElementById("reset-journey-btn");

// Reset journey button
if (resetJourneyBtn) {
    resetJourneyBtn.addEventListener("click", function(){
        // Show confirmation modal instead of alert
        showResetConfirmationModal();
    });
}

/**
 * Show success modal after adding bundle to cart with options to view cart or create another
 */
function showBundleSuccessModal() {
    var currentLang = localStorage.getItem('lang') || 'en';
    var currentTranslations = JSON.parse(localStorage.getItem('customLocketLocalization')) || {};
    var successMessage = currentTranslations[currentLang]?.bundle_added_success || 'Bundle added to cart successfully!';
    var viewCartText = currentTranslations[currentLang]?.view_cart || 'View Cart';
    var createAnotherText = currentTranslations[currentLang]?.create_another_bundle || 'Create Another Bundle';

    // Get modal elements
    var modal = document.getElementById("locket-modal");
    var modalMessage = document.getElementById("locket-modal-message");

    if (modal && modalMessage) {
        // Create buttons container
        var buttonsContainer = document.createElement('div');
        buttonsContainer.className = 'modal-buttons-container';
        buttonsContainer.style.cssText = 'display: flex; gap: 15px; justify-content: center; margin-top: 20px; flex-wrap: wrap;';

        // Create "View Cart" button
        var viewCartButton = document.createElement('button');
        viewCartButton.className = 'modal-confirm-btn';
        viewCartButton.textContent = viewCartText;
        viewCartButton.style.cssText = 'background: #0D6A37; color: white; border: 2px solid #0D6A37; border-radius: 8px; padding: 10px 30px; font-size: 15px; font-weight: bold; cursor: pointer; transition: all 0.3s ease; min-width: 150px;';
        viewCartButton.onmouseover = function() { this.style.background = '#0a5529'; };
        viewCartButton.onmouseout = function() { this.style.background = '#0D6A37'; };
        viewCartButton.onclick = function() {
            hideModal();
            window.location.href = '/cart';
        };

        // Create "Create Another Bundle" button
        var createAnotherButton = document.createElement('button');
        createAnotherButton.className = 'modal-cancel-btn';
        createAnotherButton.textContent = createAnotherText;
        createAnotherButton.style.cssText = 'background: #ffc6d1; color: #0e6b37; border: 2px solid #0e6b37; border-radius: 8px; padding: 10px 30px; font-size: 15px; font-weight: bold; cursor: pointer; transition: all 0.3s ease; min-width: 150px;';
        createAnotherButton.onmouseover = function() { this.style.background = '#ffb3c1'; };
        createAnotherButton.onmouseout = function() { this.style.background = '#ffc6d1'; };
        createAnotherButton.onclick = function() {
            hideModal();
            // Reset journey so user can start a new one
            if (typeof resetJourney === 'function') {
                resetJourney();
            }
            // Don't redirect - stay on page so user can create another bundle
        };

        // Clear any existing buttons
        var existingButtons = modalMessage.querySelector('.modal-buttons-container');
        if (existingButtons) {
            existingButtons.remove();
        }

        // Set message and add buttons
        modalMessage.innerHTML = '<p style="margin-bottom: 0; font-size: 16px; text-align: center;">' + successMessage + '</p>';
        buttonsContainer.appendChild(viewCartButton);
        buttonsContainer.appendChild(createAnotherButton);
        modalMessage.appendChild(buttonsContainer);

        // Show modal
        showModal('');
    } else {
        // Fallback if modal doesn't exist - just redirect to cart
        window.location.href = '/cart';
    }
}

/**
 * Show confirmation modal for reset journey
 */
function showResetConfirmationModal() {
    var currentLang = localStorage.getItem('lang') || 'en';
    var currentTranslations = JSON.parse(localStorage.getItem('customLocketLocalization')) || {};
    var confirmMessage = currentTranslations[currentLang]?.reset_journey_confirm || 'Are you sure you want to reset your journey? All your progress will be lost.';
    
    // Create confirmation modal content
    var modal = document.getElementById("locket-modal");
    var modalMessage = document.getElementById("locket-modal-message");
    
    if (modal && modalMessage) {
        // Create buttons container
        var buttonsContainer = document.createElement('div');
        buttonsContainer.className = 'modal-buttons-container';
        buttonsContainer.style.cssText = 'display: flex; gap: 15px; justify-content: center; margin-top: 20px;';
        
        // Create Yes button
        var yesButton = document.createElement('button');
        yesButton.className = 'modal-confirm-btn';
        yesButton.textContent = currentTranslations[currentLang]?.modal_yes || 'Yes';
        yesButton.style.cssText = 'background: #0D6A37; color: white; border: 2px solid #0D6A37; border-radius: 8px; padding: 10px 30px; font-size: 15px; font-weight: bold; cursor: pointer; transition: all 0.3s ease;';
        yesButton.onmouseover = function() { this.style.background = '#0a5529'; };
        yesButton.onmouseout = function() { this.style.background = '#0D6A37'; };
        yesButton.onclick = function() {
            hideModal();
            resetJourney();
        };
        
        // Create No button
        var noButton = document.createElement('button');
        noButton.className = 'modal-cancel-btn';
        noButton.textContent = currentTranslations[currentLang]?.modal_no || 'No';
        noButton.style.cssText = 'background: #ffc6d1; color: #0e6b37; border: 2px solid #0e6b37; border-radius: 8px; padding: 10px 30px; font-size: 15px; font-weight: bold; cursor: pointer; transition: all 0.3s ease;';
        noButton.onmouseover = function() { this.style.background = '#ffb3c1'; };
        noButton.onmouseout = function() { this.style.background = '#ffc6d1'; };
        noButton.onclick = function() {
            hideModal();
        };
        
        // Clear any existing buttons
        var existingButtons = modalMessage.querySelector('.modal-buttons-container');
        if (existingButtons) {
            existingButtons.remove();
        }
        
        // Set message and add buttons
        modalMessage.innerHTML = '<p style="margin-bottom: 0;">' + confirmMessage + '</p>';
        buttonsContainer.appendChild(yesButton);
        buttonsContainer.appendChild(noButton);
        modalMessage.appendChild(buttonsContainer);
        
        // Show modal
        showModal('');
    }
}

navArrowReverse.addEventListener("click", function(){
    goBack();
});
navArrow.addEventListener("click", function(){
    console.log('Navigation button clicked');
    // Block navigation if button is disabled (after adding to cart)
    if (navArrow.disabled || navArrow.style.pointerEvents === 'none') {
      console.log('Navigation next button is disabled - cart addition in progress');
      return;
    }
    
    var backstack = JSON.parse(localStorage.getItem('backstack'));
    var currentLang = localStorage.getItem('lang') || 'en';
    var currentTranslations = JSON.parse(localStorage.getItem('customLocketLocalization')) || {};
    console.log(backstack[backstack.length -1]);
    switch(backstack[backstack.length -1]){
        case "page-start":
            break;
        case "page-locket":
            var message = currentTranslations[currentLang]?.skip_locket_selection_error || currentTranslations[currentLang]?.error_select_locket_first || "Please select a locket first";
            showModal(message);
            break;
        case "page-outer-charm":
            confirmSelectionBtn();
            break;
        case "page-end":
            break;
        case "page-options":
            break;
        case "page-outer-charm:option-list":
            var currentLang = localStorage.getItem('lang') || 'en';
            var currentTranslations = JSON.parse(localStorage.getItem('customLocketLocalization')) || {};
            var errorMsg = currentTranslations[currentLang]?.error_select_option || "Please select one of the options";
            alert(errorMsg);
            break;
        case "page-outer-charm:option-text-field":
            confirmSelectionBtn();
            break;
        case "page-outer-charm:option-photo":
            confirmSelectionBtn();
            break;
        case "page-outer-charm:option-list-inner-charms":
            confirmSelectionBtn();
            break;
        case "page-outer-charm:option-list-gliter":
            confirmSelectionBtn();
            break;
        case "page-outer-charm:option-list-gliter-half":
            confirmSelectionBtn();
            break;
        default:
            break;
    }
    
    // Update nav title after navigation
    setTimeout(updateNavTitle, 50);
});


// Functions
function startFlow(){
    const lang = localStorage.getItem('lang') || 'en';
    var pageStart = document.getElementById("page-start");
    var pageLocket = document.getElementById("page-locket");
    var pageNavigation = document.getElementById("navigation");
    var comfrimSection = document.getElementById("confirm-selection-button");
    console.log("translations",translations[lang].locket_title);
    console.log("lang",lang);
    navTitle.innerText = translations[lang].locket_title;
    const currentLang = localStorage.getItem('lang') || 'en';
    const currentTranslations = JSON.parse(localStorage.getItem('customLocketLocalization')) || {};
    comfrimSection.innerText = currentTranslations[currentLang]?.confirm_selection_btn_label || translations[lang]?.confirm_selection_btn_label || 'Confirm Selection';
    
    // Set reset button label
    var resetBtn = document.getElementById("reset-journey-btn");
    if (resetBtn) {
        resetBtn.textContent = currentTranslations[currentLang]?.reset_button_label || 'Reset';
    }
    hidePage(pageStart);
    showPage(pageLocket);
    showPage(navTitle);
    showPage(pageNavigation);
    backstack.push(pageStart.id);
    backstack.push(pageLocket.id);
    console.log("backstack",backstack);
    // Save the backstack to localStorage
    // Ensure backstack is always stored as an array in localStorage
    localStorage.setItem('backstack', JSON.stringify(Array.from(backstack)));
    // Save page state after starting flow
    setTimeout(savePageState, 100);
}

// Helper functions to clear options when going back
function clearPhotoOption() {
    // Clear photo from localStorage
    localStorage.removeItem('uploadedPhoto');
    
    // Clear photo input field
    var photoField = document.getElementById('option-photo-field');
    if (photoField) {
        photoField.value = '';
    }
    
    // Clear background image
    var backgroundImage = document.getElementById('background-image');
    if (backgroundImage) {
        backgroundImage.style.backgroundImage = '';
        backgroundImage.classList.remove('has-photo');
    }
    
    // Hide background controls
    var backgroundControls = document.getElementById('background-controls');
    if (backgroundControls) {
        backgroundControls.classList.remove('visible');
        backgroundControls.style.pointerEvents = 'none';
    }
    
    // Reset background transform (try to access from global scope)
    try {
        if (typeof window.backgroundScale !== 'undefined') {
            window.backgroundScale = 1;
            window.backgroundOffsetX = 0;
            window.backgroundOffsetY = 0;
            window.backgroundRotation = 0;
            if (typeof window.updateBackgroundTransform === 'function') {
                window.updateBackgroundTransform();
            }
        } else if (typeof backgroundScale !== 'undefined') {
            backgroundScale = 1;
            backgroundOffsetX = 0;
            backgroundOffsetY = 0;
            backgroundRotation = 0;
            if (typeof updateBackgroundTransform === 'function') {
                updateBackgroundTransform();
            }
        }
    } catch(e) {
        console.log('Could not reset background transform:', e);
    }
    
    console.log('Photo option cleared');
}

function clearTextOption() {
    // Clear text from localStorage
    localStorage.removeItem('locketCustomText');
    
    // Clear text input field
    var textInput = document.getElementById('locket-text-input');
    if (textInput) {
        textInput.value = '';
    }
    
    // Remove text element
    if (typeof removeTextElement === 'function') {
        removeTextElement();
    } else {
        var textOverlay = document.getElementById('text-overlay');
        if (textOverlay) {
            textOverlay.textContent = '';
            textOverlay.style.clipPath = '';
        }
    }
    
    console.log('Text option cleared');
}

function clearOuterCharmsOption() {
    // Clear outer charms from localStorage
    localStorage.removeItem('selectedItems');
    
    // Clear charmPlacedAt set if it exists (try global scope first)
    try {
        var charmPlacedAtSet = window.charmPlacedAt || (typeof charmPlacedAt !== 'undefined' ? charmPlacedAt : null);
        if (charmPlacedAtSet && typeof charmPlacedAtSet.clear === 'function') {
            charmPlacedAtSet.clear();
        }
    } catch(e) {
        console.log('Could not clear charmPlacedAt:', e);
    }
    
    // Remove all placed charms from DOM
    var dotsContainer = document.getElementById('dots-container');
    if (dotsContainer) {
        var allCharms = dotsContainer.querySelectorAll('.placed-charm');
        allCharms.forEach(function(charm) {
            charm.remove();
        });
        
        // Show all red dots again
        var allDots = dotsContainer.querySelectorAll('.red-dot');
        allDots.forEach(function(dot) {
            dot.style.backgroundColor = "red";
        });
    }
    
    console.log('Outer charms option cleared');
}

function clearInnerCharmsOption() {
    // Clear inner charms from localStorage
    localStorage.removeItem('innerCharms');
    
    // Clear placedInnerCharms array if it exists (try global scope first)
    try {
        var placedInnerCharmsArray = window.placedInnerCharms || (typeof placedInnerCharms !== 'undefined' ? placedInnerCharms : null);
        if (placedInnerCharmsArray && Array.isArray(placedInnerCharmsArray)) {
            placedInnerCharmsArray.length = 0;
        }


    } catch(e) {
        console.log('Could not clear placedInnerCharms:', e);
    }
    
    // Remove all placed inner charms from DOM
    var dotsContainer = document.getElementById('dots-container');
    if (dotsContainer) {
        var allInnerCharms = dotsContainer.querySelectorAll('.placed-inner-charm');
        allInnerCharms.forEach(function(charm) {
            charm.remove();
        });
    }

    var deleteBtns = document.querySelectorAll('.inner-charm-delete-btn');
    var rotateBtns = document.querySelectorAll('.inner-charm-rotate-btn');
    deleteBtns.forEach(function(btn) {
        btn.remove();
    });
    rotateBtns.forEach(function(btn) {
        btn.remove();
    });


    // Reset inner charm counter if it exists
    try {
        if (typeof window.innerCharmCounter !== 'undefined') {
            window.innerCharmCounter = 0;
        } else if (typeof innerCharmCounter !== 'undefined') {
            innerCharmCounter = 0;
        }
    } catch(e) {
        console.log('Could not reset innerCharmCounter:', e);
    }
    
    console.log('Inner charms option cleared');
}

function clearGlitterOption() {
    // Clear glitter from localStorage
    localStorage.removeItem('selectedGlitter');
    
    // Clear background image
    var backgroundImage = document.getElementById('background-image');
    if (backgroundImage) {
        backgroundImage.style.backgroundImage = '';
        backgroundImage.classList.remove('has-photo');
    }
    
    // Hide background controls
    var backgroundControls = document.getElementById('background-controls');
    if (backgroundControls) {
        backgroundControls.classList.remove('visible');
        backgroundControls.style.pointerEvents = 'none';
    }
    
    console.log('Glitter option cleared');
}

function goBack() {
    // var pageStart = document.getElementById("page-start");
    // var pageLocket = document.getElementById("page-locket");

    // pageStart.style.display = "flex";
    // pageLocket.style.display = "none";

    backstack = JSON.parse(localStorage.getItem('backstack'));
    if (backstack.length > 0) {
        var poppedPage = backstack.pop();
        localStorage.setItem('backstack', JSON.stringify(backstack));
        backstack = JSON.parse(localStorage.getItem('backstack'));

        if (poppedPage) {
            console.log("poppedPage", poppedPage);

            if(poppedPage.includes(":")){
                //back to option 
                console.log("poppedPage in if", poppedPage === "page-outer-charm:option-list");
                

                if(poppedPage === "page-outer-charm:option-list"){
                    // Clear outer charms when going back
                    clearOuterCharmsOption();
                    
                    document.getElementById("option-list-outer-charms").classList.remove('hide');
                    document.querySelector(".divided-confrim-section").classList.remove('hide');

                    document.getElementById("option-list").classList.add('hide');
                    document.getElementById("option-text-field").classList.add('hide');
                    document.getElementById("option-photo").classList.add('hide');
                    document.getElementById("option-list-inner-charms").classList.add('hide');
                    document.getElementById("option-list-gliter").classList.add('hide');
               
                }else if(poppedPage === "page-outer-charm:option-text-field"){
                    // Clear text when going back
                    clearTextOption();
                    
                    document.getElementById("option-list").classList.remove('hide');
                    document.querySelector(".divided-confrim-section").classList.add('hide');
                    
                    // Restore option list content
                    restoreOptionListContent();

                    document.getElementById("option-text-field").classList.add('hide');
                    document.getElementById("option-photo").classList.add('hide');
                    document.getElementById("option-list-outer-charms").classList.add('hide');
                    document.getElementById("option-list-inner-charms").classList.add('hide');
                    document.getElementById("option-list-gliter").classList.add('hide');
                }else if(poppedPage === "page-outer-charm:option-photo"){
                    // Clear photo when going back
                    clearPhotoOption();
                    
                    document.getElementById("option-list").classList.remove('hide');
                    document.querySelector(".divided-confrim-section").classList.add('hide');
                    
                    // Restore option list content
                    restoreOptionListContent();

                    document.getElementById("option-text-field").classList.add('hide');
                    document.getElementById("option-photo").classList.add('hide');
                    document.getElementById("option-list-outer-charms").classList.add('hide');
                    document.getElementById("option-list-inner-charms").classList.add('hide');
                    document.getElementById("option-list-gliter").classList.add('hide');
                }else if(poppedPage === "page-outer-charm:option-list-inner-charms"){
                    // Clear inner charms when going back
                    clearInnerCharmsOption();
                    
                    if(backstack.includes("page-outer-charm:option-text-field")){
                        document.getElementById("option-list").classList.add('hide');
                        document.querySelector(".divided-confrim-section").classList.remove('hide');
    
                        document.getElementById("option-text-field").classList.remove('hide');
                        document.getElementById("option-photo").classList.add('hide');
                        document.getElementById("option-list-outer-charms").classList.add('hide');
                        document.getElementById("option-list-inner-charms").classList.add('hide');
                        document.getElementById("option-list-gliter").classList.add('hide');
                    }else{
                        document.getElementById("option-list").classList.remove('hide');
                        document.querySelector(".divided-confrim-section").classList.add('hide');
                        
                        // Restore option list content
                        restoreOptionListContent();
    
                        document.getElementById("option-text-field").classList.add('hide');
                        document.getElementById("option-photo").classList.add('hide');
                        document.getElementById("option-list-outer-charms").classList.add('hide');
                        document.getElementById("option-list-inner-charms").classList.add('hide');
                        document.getElementById("option-list-gliter").classList.add('hide');
                    }
                }else if(poppedPage === "page-outer-charm:option-list-gliter"){
                    // Clear glitter when going back
                    clearGlitterOption();
                    
                    document.querySelector(".divided-confrim-section").classList.remove('hide');
                    document.getElementById("option-list-inner-charms").classList.remove('hide');
                    document.getElementById("option-list-gliter").classList.add('hide');

                    document.getElementById("option-list").classList.add('hide');
                    document.getElementById("option-text-field").classList.add('hide');
                    document.getElementById("option-photo").classList.add('hide');
                    document.getElementById("option-list-outer-charms").classList.add('hide');
                    
                    // Update inner charm counter when going back to inner charms
                    setTimeout(function() {
                        if (typeof updateInnerCharmCounter === 'function') {
                            updateInnerCharmCounter();
                        }
                    }, 100);

                }else if(poppedPage === "page-outer-charm:option-list-gliter-half"){
                    // Clear glitter when going back
                    clearGlitterOption();
                    
                    document.querySelector(".divided-confrim-section").classList.remove('hide');
                    document.getElementById("option-list-inner-charms").classList.remove('hide');
                    document.getElementById("option-list-gliter-half").classList.add('hide');

                    document.getElementById("option-list").classList.add('hide');
                    document.getElementById("option-text-field").classList.add('hide');
                    document.getElementById("option-photo").classList.add('hide');
                    document.getElementById("option-list-outer-charms").classList.add('hide');
                    
                    // Update inner charm counter when going back to inner charms
                    setTimeout(function() {
                        if (typeof updateInnerCharmCounter === 'function') {
                            updateInnerCharmCounter();
                        }
                    }, 100);

                }else if(poppedPage === "page-outer-charm:locket-screenshot"){
                    // Show and enable navigation buttons when going back from preview
                    const navArrow = document.getElementById("nav-arrow");
                    const navArrowReverse = document.getElementById("nav-arrow-reverse");
                    if(navArrow) {
                        navArrow.style.display = "";
                        navArrow.disabled = false;
                        navArrow.style.pointerEvents = "auto";
                    }
                    if(navArrowReverse) {
                        navArrowReverse.style.display = "";
                        navArrowReverse.disabled = false;
                        navArrowReverse.style.pointerEvents = "auto";
                    }
                }

            }else{

                //back to page

                var hidePageElement = document.getElementById(poppedPage);
                hidePageElement.classList.add("hide");
    
                var showPageElement = document.getElementById(backstack[backstack.length - 1]);
                if (showPageElement) {
                    console.log("showPageElement", showPageElement);
                    showPageElement.classList.remove("hide");
                }
    
                //If start page
                if (showPageElement.id === 'page-start') {
                    hideNavigation();
                localStorage.setItem('backstack', JSON.stringify([]));
                backstack = [];
                // Clear page state when returning to start
                localStorage.removeItem('pageState');
                // Ensure PDF modal listeners are set up
                setTimeout(setupPdfModalListeners, 100);
                }
            }
        }
    }
    
    // Update nav title after going back
    setTimeout(updateNavTitle, 50);
    
    // Save state after going back
    setTimeout(savePageState, 100);

    // var poppedPage = backstack.pop();
    // if (poppedPage) {
    //     var pageElement = document.getElementById(poppedPage.replace(/([A-Z])/g, '-$1').toLowerCase());
    //     if (pageElement) {
    //         pageElement.classList.add("hide");
    //     }
    //     // Check the item right before the popped item and remove hide class from it
    //     if (backstack.length > 0) {
    //         var previousPage = backstack[backstack.length - 1];
    //         var previousPageElement = document.getElementById(previousPage.replace(/([A-Z])/g, '-$1').toLowerCase());
    //         if (previousPageElement) {
    //             previousPageElement.classList.remove("hide");
    //         }
    //     }
    // // Update the backstack in localStorage after popping
    // localStorage.setItem('backstack', JSON.stringify(backstack));
    // }

    // console.log(backstack);
    // if(backstack.length > 0){
    //     var page = backstack.pop();
    //     if(page == document.getElementById("page-start")){
    //         hideNavigation();
    // hideAllPages();
    //         showPage(page);
    //         showPage(navTitle);
    //         showPage(pageNavigation);

    //     }
    // }
}

function hideNavigation(){
    var pages = document.querySelectorAll(".navigation");
    pages.forEach(page => {
        page.classList.add("hide");
    });
}

function hideAllPages(){
    var pages = document.querySelectorAll(".page");
    pages.forEach(page => {
        page.classList.add("hide");
    });

    var sections = document.querySelectorAll(".section");
    sections.forEach(section => {
        section.classList.add("hide");
    });
}

function handleOptionClick(option) {
    var backstack = JSON.parse(localStorage.getItem('backstack'));
    var selectedLocket = JSON.parse(localStorage.getItem('selectedLocket'));

    console.log("dimension_description",selectedLocket.metafields.dimension_description);
    console.log("locket_options",selectedLocket.metafields.locket_options);

    // Normal click handler logic here
    console.log("Option clicked:", option);
    console.log("====>",option.toLowerCase() ==="name & charms");

    if(option.toLowerCase() ==="photo"){
        backstack.push("page-outer-charm:option-photo");
        controlOptionPage("option-photo");
    }
    else if(option.toLowerCase() ==="name & charms"){
        backstack.push("page-outer-charm:option-text-field");
        controlOptionPage("option-text-field");
    }
    else if(option.toLowerCase() ==="charms"){  
          backstack.push("page-outer-charm:option-list-inner-charms");
          controlOptionPage("option-list-inner-charms");
          
          // Update inner charm counter after navigating to charms
          setTimeout(function() {
              if (typeof updateInnerCharmCounter === 'function') {
                  updateInnerCharmCounter();
              }
          }, 100);
    }
    localStorage.setItem('backstack', JSON.stringify(backstack));
    // Update nav title after option click
    setTimeout(updateNavTitle, 50);
    // State will be saved by controlOptionPage, but save again to be sure
    setTimeout(savePageState, 150);

    // controlOptionPage(option);
}

function confirmSelectionBtn(){
    var selectedLocket = JSON.parse(localStorage.getItem('selectedLocket'));
    var options = selectedLocket.metafields.locket_options;
    var backstack = JSON.parse(localStorage.getItem('backstack'));

    console.log("options => ",options);

    if(backstack.includes("page-outer-charm:option-list")){
        // Change red dots to transparent and remove green border when navigating within outer-charm flow
        var dotsContainer = document.getElementById('dots-container');
        if(dotsContainer){
            var allRedDots = dotsContainer.querySelectorAll('.red-dot');
            allRedDots.forEach(function(dot) {
                dot.style.backgroundColor = 'transparent';
                dot.classList.remove('active'); // Remove green border
            });
        }
        
        // Hide red dot controls
        var redDotControls = document.getElementById("red-dot-controls");
        if(redDotControls){
            redDotControls.style.display = 'none';
            redDotControls.style.opacity = '0';
        }
        
        switch (backstack[backstack.length - 1]) {
            case "page-outer-charm:option-photo":
                // Directly add to cart instead of showing screenshot
                addAllItemsToCart();
            break;

            case "page-outer-charm:option-text-field":
                backstack.push("page-outer-charm:option-list-inner-charms");
                controlOptionPage("option-list-inner-charms");
                
                // Update inner charm counter after navigating from text option
                setTimeout(function() {
                    if (typeof updateInnerCharmCounter === 'function') {
                        updateInnerCharmCounter();
                    }
                }, 100);
            break;

            case "page-outer-charm:option-list-inner-charms":
                // Hide inner-charms controls when leaving inner-charms page
                var innerCharmControls = document.getElementById("inner-charm-controls");
                if(innerCharmControls){
                    innerCharmControls.style.display = 'none';
                    innerCharmControls.style.opacity = '0';
                }
                
                // Hide all inner charm control buttons (delete and rotate)
                hideInnerCharmControls();
                
                if(backstack.includes("page-outer-charm:option-text-field")){
                    backstack.push("page-outer-charm:option-list-gliter-half");
                    controlOptionPage("option-list-gliter-half");
                }else{
                    backstack.push("page-outer-charm:option-list-gliter");
                    controlOptionPage("option-list-gliter");
                }
                // backstack.push("page-outer-charm:option-list-gliter");
                // controlOptionPage("option-list-gliter");
            break;
        
            case "page-outer-charm:option-list-gliter":
                // Directly add to cart instead of showing screenshot
                addAllItemsToCart();
            break;
        
            case "page-outer-charm:option-list-gliter-half":
                // Directly add to cart instead of showing screenshot
                addAllItemsToCart();
            break;

            case "page-outer-charm:locket-screenshot":
                addAllItemsToCart();
            break;
            default:
                break;
        }
        localStorage.setItem('backstack', JSON.stringify(backstack));
    }else{
        var optionHorizontalOptionsList = document.getElementById("option-list");
        var dividedConfrimSection = document.querySelector(".divided-confrim-section");
        
        // Hide outer-charms controls when leaving outer-charms page
        var redDotControls = document.getElementById("red-dot-controls");
        if(redDotControls){
            redDotControls.style.display = 'none';
            redDotControls.style.opacity = '0';
        }
        
        // Change red dots to transparent and remove green border
        var dotsContainer = document.getElementById('dots-container');
        if(dotsContainer){
            var allRedDots = dotsContainer.querySelectorAll('.red-dot');
            allRedDots.forEach(function(dot) {
                dot.style.backgroundColor = 'transparent';
                dot.classList.remove('active'); // Remove green border
            });
            
            // Hide all outer charm control buttons (delete and rotate)
            var allOuterCharms = dotsContainer.querySelectorAll('.placed-charm');
            allOuterCharms.forEach(function(charm) {
                var deleteBtn = charm.querySelector('.delete-button');
                var rotateBtn = charm.querySelector('.rotate-button');
                if (deleteBtn) deleteBtn.classList.add('hidden');
                if (rotateBtn) rotateBtn.classList.add('hidden');
            });
        }
    
        var optionInstructionTitle = document.getElementById("option-instruction-title");
        
        // Get current language and translations dynamically
        var currentLang = localStorage.getItem('lang') || 'en';
        var currentTranslations = JSON.parse(localStorage.getItem('customLocketLocalization')) || {};
        if (optionInstructionTitle) {
            var titleText = currentTranslations[currentLang]?.option_list_page_title || translations[lang]?.option_list_page_title || "select the options that your go with!";
            setTextWithLineBreak(optionInstructionTitle, titleText);
        }
    
        // Clear any existing items
        if (optionHorizontalOptionsList) {
            optionHorizontalOptionsList.innerHTML = "";
        }
        
        // Create and append new items from 'options'
        if (Array.isArray(options) && optionHorizontalOptionsList) {
            options.forEach(function(option) {
                var item = document.createElement("div");
                item.className = "option-horiontal-options-list-item";
                if(option === 'Name & Charms'){
                    item.textContent = currentTranslations[currentLang]?.[`locket_options_name`] || translations[lang]?.[`locket_options_name`] || '';
                }else{
                    item.textContent = currentTranslations[currentLang]?.[`locket_options_${option.toLowerCase()}`] || translations[lang]?.[`locket_options_${option.toLowerCase()}`] || '';
                }
                item.onclick = function() {
                    handleOptionClick(option);
                };
    
                optionHorizontalOptionsList.appendChild(item);
            });
        }
        
        // Show the option-list and hide divided confirm section
        // Call controlOptionPage AFTER setting up the content
        console.log('About to show option-list, element exists:', !!optionHorizontalOptionsList);
        
        // First, ensure all other option pages are hidden
        var allOptionPages = [
            "option-list-outer-charms",
            "option-list-inner-charms",
            "option-text-field",
            "option-photo",
            "option-list-gliter",
            "option-list-gliter-half"
        ];
        allOptionPages.forEach(function(id) {
            var el = document.getElementById(id);
            if (el) {
                el.classList.add("hide");
            }
        });
        
        // Now show the option-list
        if (optionHorizontalOptionsList) {
            optionHorizontalOptionsList.classList.remove("hide");
            console.log('option-list hide class removed, has hide:', optionHorizontalOptionsList.classList.contains('hide'));
        }
        

        
        // Hide divided confirm section
        if (dividedConfrimSection) {
            dividedConfrimSection.classList.add("hide");
        }
        
        // Call controlOptionPage to ensure proper state
        controlOptionPage("option-list");
        
        // Ensure page-outer-charm is visible
        var pageOuterCharm = document.getElementById('page-outer-charm');
        if (pageOuterCharm) {
            pageOuterCharm.classList.remove('hide');
            console.log('page-outer-charm is visible:', !pageOuterCharm.classList.contains('hide'));
        }
        
        // Double-check visibility after controlOptionPage
        if (optionHorizontalOptionsList) {
            optionHorizontalOptionsList.classList.remove("hide");
            // Force display in case CSS is hiding it
            optionHorizontalOptionsList.style.display = '';
            var computedStyle = window.getComputedStyle(optionHorizontalOptionsList);
            console.log('After controlOptionPage, option-list visible:', !optionHorizontalOptionsList.classList.contains('hide'));
            console.log('option-list display:', computedStyle.display);
            console.log('option-list visibility:', computedStyle.visibility);
            console.log('option-list opacity:', computedStyle.opacity);
            
            // If still hidden, force it visible
            if (computedStyle.display === 'none' || optionHorizontalOptionsList.classList.contains('hide')) {
                console.warn('Force showing option-list');
                optionHorizontalOptionsList.style.display = 'block';
                optionHorizontalOptionsList.classList.remove("hide");
            }
        } else {
            console.error('option-list element not found!');
        }
    
        backstack.push("page-outer-charm:option-list");
        localStorage.setItem('backstack', JSON.stringify(backstack));
          // Update nav title after confirming selection
          setTimeout(updateNavTitle, 50);
        // Save state after showing options (with delay to ensure visibility)
        setTimeout(function() {
            savePageState();
            console.log('State saved after showing options');
        }, 200);
    }

    // console.log(selectedLocket);
    // var pageOuterCharm = document.getElementById("page-outer-charm");
    // pageOuterCharm.classList.add("hide");
    // var pageEnd = document.getElementById("page-end");
    // pageEnd.classList.remove("hide");
    // var pageNavigation = document.getElementById("navigation");
    // pageNavigation.classList.add("hide");
    // var navTitle = document.getElementById("nav-title");
    // navTitle.classList.add("hide");
}

async function showLocketScreenshot(){

    //sections
    const middleSection = document.getElementById("divided-middle-section");
    const bottomSection = document.getElementById("divided-bottom-section");
    const confirmSelectionSection = document.getElementById("divided-confrim-section");

    //controls
    const innerCharmControls = document.getElementById("inner-charm-controls");
    const outerCharmControls = document.getElementById("outer-charm-controls");
    const glitterControls = document.getElementById("glitter-control-layer");
    const photoControls = document.getElementById("photo-controls-layer");
    const textFieldControls = document.getElementById("text-field-controls");
    const optionListControls = document.getElementById("option-list-controls");
    const optionListInnerCharmsControls = document.getElementById("option-list-inner-charms-controls");
    const optionListOuterCharmsControls = document.getElementById("option-list-outer-charms-controls");
    const redDots = document.querySelectorAll('.red-dot');
    const charmControlButtons = document.querySelectorAll('button.charm-control-button');
    const polygonSvg = document.getElementById("polygon-svg");
    const imageMap = document.getElementById("image-map");


    if(middleSection) {
        middleSection.remove();
    }
    if(bottomSection) {
    bottomSection.remove();
    }
    if(confirmSelectionSection) {
        confirmSelectionSection.remove();
    }
    if(innerCharmControls) {
      innerCharmControls.remove();
    }
    if(outerCharmControls) {
      outerCharmControls.remove();
    }
    if(glitterControls) {
      glitterControls.remove();
    }
    if(photoControls) {
      photoControls.remove();
    }
    if(textFieldControls) {
      textFieldControls.remove();
    }
    if(optionListControls) {
      optionListControls.remove();
    }
    if(optionListInnerCharmsControls) {
      optionListInnerCharmsControls.remove();
    }
    if(optionListOuterCharmsControls) {
      optionListOuterCharmsControls.remove();
    }
    if(redDots) {
        redDots.forEach(el => el.remove());
    }
    if(charmControlButtons) {
        charmControlButtons.forEach(btn => btn.remove());
    }
    if(polygonSvg) {
        polygonSvg.remove();
    }
    if(imageMap) {
        imageMap.remove();
    }

    // document.querySelectorAll('.placed-charm').forEach(el => {
    //     el.style.removeProperty('transform'); // remove inline
    //     el.style.setProperty('transform', 'none', 'important'); // kill CSS
    //   });

    const previewSection = document.getElementById("preview-section");
    const previewLoader = document.getElementById("preview-loader");
    const loaderText = previewLoader ? previewLoader.querySelector('.loader-text') : null;
    const generatingText = document.getElementById("generating-text");
    const showPreviewButton = document.getElementById("show-preview-button");

    // Show preview section and loader with "Generating your Locket" text
    if(previewSection) {
      previewSection.classList.remove("hide");
      previewSection.style.display = "flex";
      previewSection.style.justifyContent = "center";
      previewSection.style.alignItems = "center";
      previewSection.style.position = "relative";
      previewSection.style.zIndex = "9000";
    }

    // Keep show preview button visible and enabled (user can retry if generation lags)
    if(showPreviewButton) {
      showPreviewButton.classList.add('show');
      showPreviewButton.disabled = false;
      showPreviewButton.style.pointerEvents = "auto";
      showPreviewButton.style.opacity = "1";
    }
    if(generatingText) {
      generatingText.classList.remove('hide');
    }

    // Show hint text when preview section is displayed
    const previewHintText = document.getElementById("preview-hint-text");
    if(previewHintText) {
      previewHintText.classList.remove('hide');
    }

    // Hide and disable navigation buttons on preview page
    const navArrow = document.getElementById("nav-arrow");
    const navArrowReverse = document.getElementById("nav-arrow-reverse");
    if(navArrow) {
      navArrow.style.display = "none";
      navArrow.disabled = true;
      navArrow.style.pointerEvents = "none";
    }
    if(navArrowReverse) {
      navArrowReverse.style.display = "none";
      navArrowReverse.disabled = true;
      navArrowReverse.style.pointerEvents = "none";
    }

    // Show loader and update text
    if(previewLoader) {
      previewLoader.style.display = "flex";
    }
    if(loaderText) {
      loaderText.textContent = "Generating your Locket";
    }

    // Show screenshot container (with pink border) even if no image yet
    const screenshotContainer = document.querySelector('.locket-screenshot-container');
    if(screenshotContainer) {
      screenshotContainer.style.display = "flex";
    }
    // Hide screenshot image initially
    const locketScreenshot = document.getElementById("locket-screenshot");
    if(locketScreenshot) {
      locketScreenshot.style.display = "none";
    }

  // html2canvas logic commented out
  // const target = document.getElementById("divided-top-section");
  // console.log('✅ Target:', target);
  // const canvas = await html2canvas(target, {
  //   backgroundColor: 'transparent',
  //   scale: Math.min(window.devicePixelRatio || 1, 2),
  //   useCORS: true,
  //   allowTaint: false,
  //   logging: true,
  //
  //   ignoreElements: el => {
  //     if (el.classList?.contains('placed-charm')) return false;
  //     return (
  //       el.tagName?.includes('-') ||
  //       el.hasAttribute?.('data-shopify')
  //     );
  //   },
  //
  //   onclone: doc => {
  //     // kill transforms
  //     doc.querySelectorAll('.placed-charm').forEach(el => {
  //
  //       el.style.visibility = 'visible';
  //       el.style.opacity = '1';
  //     });
  //
  //     // fix protocol-relative images
  //     doc.querySelectorAll('img').forEach(img => {
  //       if (img.src.startsWith('//')) {
  //         img.src = window.location.protocol + img.src;
  //       }
  //       img.loading = 'eager';
  //       img.decoding = 'sync';
  //     });
  //
  //     // stop animations
  //     const style = doc.createElement('style');
  //     style.textContent = `
  //       * {
  //         animation: none !important;
  //         transition: none !important;
  //       }
  //     `;
  //     doc.head.appendChild(style);
  //
  //     // unblock fonts
  //     if (doc.fonts) {
  //       doc.fonts.ready.catch(() => {});
  //     }
  //   }
  // });
  //
  // console.log('✅ canvas ready');
  //
  // canvasToBase64(canvas);
  // showCanvas(canvas);

  const topSection = document.getElementById("divided-top-section");
  if(topSection) {
      topSection.remove();
  }

  // Update button visibility after showing preview
  if (typeof updateShowPreviewButtonVisibility === 'function') {
    updateShowPreviewButtonVisibility();
  }




}

function showCanvas(canvas) {
    const locketScreenshot = document.getElementById("locket-screenshot");
    const generatingText = document.getElementById("generating-text");
    const showPreviewButton = document.getElementById("show-preview-button");

    if (locketScreenshot && canvas) {
        locketScreenshot.src = canvas.toDataURL('image/png');
        // Ensure screenshot container is visible
        const screenshotContainer = document.querySelector('.locket-screenshot-container');
        if(screenshotContainer) {
            screenshotContainer.style.display = "flex";
        }
        // Show screenshot image
        locketScreenshot.style.display = "block";
        // Hide generating text when screenshot is ready
        if(generatingText) {
            generatingText.classList.add('hide');
        }
        // Keep show preview button enabled (though it will be hidden by updateShowPreviewButtonVisibility)
        if(showPreviewButton) {
            showPreviewButton.disabled = false;
            showPreviewButton.style.pointerEvents = "auto";
            showPreviewButton.style.opacity = "1";
        }
        // Show hint text when screenshot is ready
        const previewHintText = document.getElementById("preview-hint-text");
        if(previewHintText) {
            previewHintText.classList.remove('hide');
        }
        // Update loader visibility after setting screenshot
        if (typeof updatePreviewLoaderVisibility === 'function') {
            updatePreviewLoaderVisibility();
        }
    }
}

function canvasToBase64(canvas, type = 'image/png', quality = 1) {
if (!canvas) return null;
const base64 = canvas.toDataURL(type, quality);
console.log('Base64:', base64);
localStorage.setItem('locketScreenshot', base64);
// Hide the "Show Your Locket" button after screenshot is saved
updateShowPreviewButtonVisibility();
return base64;
}

function hideLocketPreview(){
    // Hide the preview section and screenshot
    var previewSection = document.getElementById("preview-section");
    var locketScreenshotVar = document.getElementById("locket-screenshot");

    if (previewSection) {
        previewSection.classList.add("hide");
        previewSection.style.display = "none";
    }
    if (locketScreenshotVar) {
        locketScreenshotVar.classList.add("hide");
        locketScreenshotVar.style.display = "none";
    }

    // Show top, middle, and bottom sections
    var topSection = document.getElementById("divided-top-section");
    var middlesection = document.getElementById("divided-middle-section");
    var bottomsection = document.getElementById("divided-bottom-section");

    if (topSection) {
        topSection.classList.remove("hide");
        topSection.style.display = "";
    }
    if (middlesection) {
        middlesection.classList.remove("hide");
        middlesection.style.display = "";
    }
    if (bottomsection) {
        bottomsection.classList.remove("hide");
        bottomsection.style.display = "";
    }
}

// async function captureLocketScreenshot(){
//     try{
//   const canvas = await html2canvas(document.getElementById("divided-top-section"), {
//     backgroundColor: null,                // transparent background
//     scale: window.devicePixelRatio || 2,  // higher quality
//     useCORS: true,                        // attempt to load cross-origin images with CORS
//     allowTaint: false,                    // keep false when using CORS
//     logging: false,
//     ignoreElements: el =>
//     el.tagName.includes('-') ||        // ignore custom elements
//     el.closest('[data-shopify]')
//   });

//     canvasToBase64(canvas);
//     showCanvas(canvas);
//     return canvas; // Return canvas for chaining if needed
//     }catch(error){
//         console.error('❌ Error in captureLocketScreenshot:', error);
//         return null;
//     }
// }

function captureLocketScreenshot() {
    // html2canvas logic commented out
    // return (async () => {
    //     console.log('✅ Capturing locket screenshot...');
    //
    //     // Check if html2canvas is loaded
    //     if (typeof html2canvas === 'undefined') {
    //         console.error('❌ html2canvas is not loaded!');
    //         return null;
    //     }
    //     console.log('✅ html2canvas is loaded');
    //
    //     // Check if element exists
    //     const targetElement = document.getElementById('divided-top-section');
    //     if (!targetElement) {
    //         console.error('❌ divided-top-section element not found!');
    //         return null;
    //     }
    //     console.log('✅ Divided top section found:', targetElement);
    //     console.log('✅ Element dimensions:', {
    //         width: targetElement.offsetWidth,
    //         height: targetElement.offsetHeight,
    //         scrollWidth: targetElement.scrollWidth,
    //         scrollHeight: targetElement.scrollHeight
    //     });
    //
    //     try {
    //         console.log('⏳ Starting html2canvas capture... (this may take a moment)');
    //         const startTime = Date.now();
    //
    //         // Add timeout wrapper
    //         const canvasPromise = html2canvas(targetElement, {
    //             backgroundColor: null,
    //             scale: window.devicePixelRatio || 2,
    //             useCORS: true,
    //             allowTaint: false,
    //             logging: true, // Enable logging temporarily to see progress
    //             onclone: (clonedDoc) => {
    //                 console.log('✅ html2canvas: Document cloned');
    //             },
    //             ignoreElements: el =>
    //                 el.tagName?.includes('-') ||
    //                 el.closest?.('[data-shopify]')
    //         });
    //
    //         // Add timeout (30 seconds)
    //         const timeoutPromise = new Promise((_, reject) => {
    //             setTimeout(() => reject(new Error('html2canvas timeout after 1 minute')), 60000);
    //         });
    //
    //         const canvas = await Promise.race([canvasPromise, timeoutPromise]);
    //         const endTime = Date.now();
    //         console.log(`✅ Canvas captured in ${endTime - startTime}ms:`, canvas);
    //         console.log('✅ Canvas dimensions:', { width: canvas.width, height: canvas.height });
    //
    //         const base64 = canvasToBase64(canvas);
    //         showCanvas(canvas);
    //         console.log('✅ Base64 length:', base64 ? base64.length : 0);
    //         return { canvas, base64 };
    //     } catch (error) {
    //         console.error('❌ Error in captureLocketScreenshot:', error);
    //         console.error('❌ Error details:', {
    //             message: error.message,
    //             stack: error.stack,
    //             name: error.name
    //         });
    //         return null;
    //     }
    // })();
    return null;
  }

function showCanvas(canvas) {
    console.log('✅ Showing canvas...');
    const locketScreenshotTarget = document.getElementById("locket-screenshot");
    const generatingText = document.getElementById("generating-text");
    const showPreviewButton = document.getElementById("show-preview-button");
    console.log('✅ Locket screenshot target found:', locketScreenshotTarget);
    if (locketScreenshotTarget && canvas) {
        locketScreenshotTarget.src = canvas.toDataURL('image/png');
        console.log('✅ Locket screenshot set:', locketScreenshotTarget.src);
        // Hide generating text when screenshot is ready
        if(generatingText) {
            generatingText.classList.add('hide');
        }
        // Keep show preview button enabled (though it will be hidden by updateShowPreviewButtonVisibility)
        if(showPreviewButton) {
            showPreviewButton.disabled = false;
            showPreviewButton.style.pointerEvents = "auto";
            showPreviewButton.style.opacity = "1";
        }
        // Show hint text when screenshot is ready
        const previewHintText = document.getElementById("preview-hint-text");
        if(previewHintText) {
            previewHintText.classList.remove('hide');
        }
        // Update loader visibility after setting screenshot
        if (typeof updatePreviewLoaderVisibility === 'function') {
            updatePreviewLoaderVisibility();
        }
    }
}

function canvasToBase64(canvas, type = 'image/png', quality = 1) {
    console.log('✅ Converting canvas to base64...');
    console.log('✅ Canvas:', canvas);
  if (!canvas) return null;
  console.log('✅ Converting canvas to base64...');
  const base64 = canvas.toDataURL(type, quality);
  console.log('✅ Base64:', base64);
  console.log('Base64:', base64);
  localStorage.setItem('locketScreenshot', base64);
  // Hide the "Show Your Locket" button after screenshot is saved
  if (typeof updateShowPreviewButtonVisibility === 'function') {
    updateShowPreviewButtonVisibility();
  }
  return base64;
}
// Aesthetic rotating messages during loading
let aestheticInterval = null;

function startAestheticMessages() {
const lang = localStorage.getItem('lang') || 'en';
const messages = {
en: [
"Each locket includes both a keychain and a necklace chain",
"Good job! You've just created your own unique masterpiece.",
"Comes in a beautiful box with everything you need to easily assemble your memory locket.",
"Memory lockets: a place to keep your memories close to your heart.",
"Memory Locket: a canvas for your creativity."
],
ar: [
"كل قلادة مع سلسلة مفاتيح وسلسلة عنق، حتى يمكنك ارتداؤها بالقرب من قلبك أو حملها معك إلى كل مكان",
"عمل رائع! لقد أنشأتِ تحفتكِ الخاصة الفريدة من نوعها.",
"تأتي في علبة أنيقة مع كل ما تحتاجينه لصنع قلادتكِ الخاصة بكل سهولة",
"مكان آمن للاحتفاظ بذكرياتك ومن تكون قريباً من قلبك",
"Memory Locket: لوحة لإبداعك."
]
};

let index = 0;
const list = messages[lang] || messages.en;

// Show first message immediately
const aestheticEl = document.querySelector('.aesthetic-loading-message');
if (aestheticEl) {
aestheticEl.textContent = list[0];
aestheticEl.style.opacity = '1';
}

// Clear any existing interval
if (aestheticInterval) clearInterval(aestheticInterval);

// Rotate every 5 seconds
aestheticInterval = setInterval(() => {
index = (index + 1) % list.length;
const el = document.querySelector('.aesthetic-loading-message');
if (el) {
el.style.opacity = '0';
setTimeout(() => {
el.textContent = list[index];
el.style.opacity = '1';
}, 400);
}
}, 5000);
}

function stopAestheticMessages() {
if (aestheticInterval) {
clearInterval(aestheticInterval);
aestheticInterval = null;
}
}
